/// <reference path="./typings/index.d.ts" />

var pageController = undefined;
var isSb = undefined;
var isTerminal = undefined;
var goBackFlag = false;
var UA = undefined;

// 流入パラメータ
var params = undefined;

// token
var token = undefined;

// 予約情報
var reservationInfo = undefined;

// 新予約画面URL
var OLS_APPLY_URL = "";
// 住所情報リスト
var addressInfo = undefined;
// テスト公開日時
var openDate = new Date().getTime();
// 業務日付
var systemDate = new Date().getTime();
// あんしん保証パック選択状態フラグ
var safePackCheckedFlg = false;
//あんしん保証パックDetai選択状態
var safePackDetailCheckedCd= '';
// あんしん保証パック選択状態の機種
var safePackItemCd = '';
// 本人確認書類リストレロード用
var isAlreadyDrownIdDocumentListlength = 0;
// 本人確認書類リスト以外レロード用
var isAdditionalIdDocumentListlength = 0;
// 本人確認書類リストレロード用
var isSbPrev = undefined;
var json = undefined;
//iPhone,SoftBank Mobile Android、4G ケータイ
var CATEGORY_PHONE = {
    '0303' : 'iPhone',
    '0402' : 'SoftBank Mobile Android',
    '1700' : '4G ケータイ'
};
//iPad、タブレット
var CATEGORY_TABLET = {
    '0500' : 'iPad',
    '1300' : 'タブレット'
};

//　年齢選択の値
var ageClassChoose = null;

/** iPhone/iPad認定店舗フラグ */
var authorizedShopFlg = true;

/** o2o対応店舗フラグ */
var o2oAvailableFlg = true;

// 受付業務:O2O
var RECEIPT_STYLE_CTRL_SHOP = "3";

// 受付業務:直送
var RECEIPT_STYLE_CTRL_HOME = "2";

/**
 * json データ
 */
// 機種情報JSON
var g_modelData = {};
// 在庫情報JSON
var g_goodsStock = {};
// 商品価格情報JSON
var g_goodsPrice = {};
// 特定グループ情報JSON
var g_spGrpData = {};

var savePosition = void 0;
var J_MODAL = new jModal('.j_modal', {
    modalSpeed: 400,
    bgOpacity: 0.6,
    closeBtn: "",
    addClass: "mg10",
    width: "864px",
    closeEnd: function () {
        Utils.scrollBody(true, savePosition);
        if (this.ModalCloseFun) {
            this.ModalCloseFun();
            delete this.ModalCloseFun;
        }
    }
});
// #topでリフレッシュでも動作できるため
location.replace('#init');

var isHashChangeHandling = false;
// hashchangeのイベントは先に設定
$(function () {

    // CasisクッキークリアAPIを呼び
    var logout = getEnviromentInfo(logoutList);
    Utils.loadScriptStatus("logout", logout);

    // hashchangeのイベントで画面遷移
    $(window).bind('hashchange', function () {

        // 画面遷移以外のhashchangeを除外する
        var exclusionHash = ['#modelTabBox', '#option'];
        if(exclusionHash.indexOf(location.hash) > -1) return;

        // loadingを表示する
        showLoading();
        isHashChangeHandling = true;

        // 本当に行っていい画面なのかチェック
        if (!$('body > div' + location.hash + ', body > div#container > main' + location.hash).hasClass('history')) return;
        // 一旦、全部消す
        $('body > div, body > div#container > main').removeClass('current');
        // 今、表示したい画面のみ表示する
        $('body > div' + location.hash + ', body > div#container > main' + location.hash).addClass('current');
        // 表示した画面より後のパンくずを消す
        $('body > div' + location.hash + '~div' + ', body > div#container > main' + location.hash).removeClass('history');
        if (location.hash === '#deviceSelect') {
            if (!initDoneFlag) {
                pageController = new PageController();
                pageController.init();
            } else {
                // ケースリフレッシュ
                $("#sliderBox").slick("refresh");
            }
        }
        // 確認画面の制御
        if (location.hash === '#confirm') {
            confirmController();
        }
        $('body').toggleClass('nonmember', !isSb);
        Utils.titleChange(location.hash);
        if (goBackFlag) {
            $('body,html').animate({
                scrollTop: $("#footer_logo").offset().top
            }, 0);
            goBackFlag = false;
        }

        isHashChangeHandling = false;
        if (location.hash != '#init' && ajaxCallNum == 0) {
            // loadingを非表示する
            hideLoading();
        }

        // IE専用
        window.history.pushState('forward', null, document.URL);
        window.history.forward(1);

        // Flow表示位置の設定
        Utils.drawSpFlow();
    });

    // すべての画面でブラザーの戻るボタンを押しても戻れないように
    if (window.history && window.history.pushState) {
        $(window).on('popstate', function () {
            window.history.pushState('forward', null, document.URL);
            window.history.forward(1);
        });
    }
});

// jQueryのお作法
// DOMの形成前にjQueryが動くのを防ぐ
var OLS = undefined;
$(function () {
    // 制御用のオブジェクトを用意
    OLS = {

        // 受取方法メリットリンク初期化
        setReceiptLink: function () {

            // メリットリンクURL区分
            var prdMeritLinkKbn = params.receiptStyleCtrl;

            // 受け取り方法が「4」「5」の場合、メリットリンク文言を設定する
            if(params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME1 || params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP1) {
                $(".w_open a span").text("選択に迷ったら。受け取り方法の特長をみる");

            // 受け取り方法が「6」の場合、メリットリンク文言を設定する
            } else if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME2) {
                $(".w_open a span").text("送料無料について詳しくみる");

            // 受け取り方法が「7」の場合、メリットリンク文言を設定する
            } else if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP2) {
                $(".w_open a span").text("店舗受け取りとは");
            } else {
                prdMeritLinkKbn = "1";
            }

            //メリットリンクURLを設定する
            var srcUrl = getEnviromentInfo(prdMeritLinkList);
            $("#receive .j_popDetail").load(srcUrl + prdMeritLinkKbn + ".html");
            popUp();
        },

        // 契約状況選択の処理
        contractStatusChange: function () {

            // 直送限定(W2T、4Gケータイ、タブレット)の場合
            if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID || ITEM_TYPE_ONLY_HOME.indexOf(arr.itemType) > -1) {

                // 18歳以上の場合
                if (params.ageCtrl == AGECLASS.C) {
                    $("#ageClass h2").text("ご契約者の年齢")
                    OLS.hideOther("ageClass", params.ageCtrl);
                }
                // 年齢表示
                $("#ageClass").show();
            } else {

                // o2o固定[3]の場合
                if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP) {
                    // 年齢を非表示(設定なし)
                    // 受け取り方法表示
                    OLS.receiptCtrlInit();
                } else {
                    // o2o固定[3]以外の場合
                    // 年齢指定の場合、指定年齢のみ表示
                    if (params.ageCtrl == AGECLASS.B || params.ageCtrl == AGECLASS.C) {
                        $("#ageClass h2").text("ご契約者の年齢")
                        OLS.hideOther("ageClass", params.ageCtrl);
                    }
                    // 年齢表示
                    $("#ageClass").show();
                }
            }
        },

        // 受け取り方法の初期処理
        receiptCtrlInit: function () {

            /**
             * 受け取り方法選択状態の初期化
             */
            // 変更可否の初期化
            $("#receiptChgCtrl .btnArea").removeClass("removeRadio");
            // 表示様式の初期化
            $("#receiptChgCtrl .btnArea label").removeClass("flex12 spFlex12").removeClass("checked").addClass("flex6 spFlex6").show();
            // ボタン活性の初期化
            $("#receiptChgCtrl .btnArea label").removeClass("disabled");
            $("#receiptChgCtrl .btnArea input").prop("checked", false).prop("disabled", false);
            // 受取方法メリットリンクを非表示
            $(".w_open").hide();
            // ボタン制御
            $('#top #link a').addClass('disabled');

            // W2T、4Gケータイ、タブレットの場合
            if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID || ITEM_TYPE_ONLY_HOME.indexOf(arr.itemType) > -1) {
                // 18歳以上の場合(URL指定、画面選択)
                if ($("[name=ageClass]:checked").val() == AGECLASS.C) {
                    // タイトル
                    $("#receiptChgCtrl h2").html('受け取り方法');
                    // 説明文言
                    $("#receiptChgCtrl p.txt").eq(0).html('自宅等でのお受け取りとなります');
                    // 表示制御
                    OLS.hideOther("receiptChgCtrl", RECEIPT_STYLE_CTRL.HOME);
                    // 受け取り方法表示
                    $("#receiptChgCtrl").show();
                    return;
                }
            }

            // 受け取り方法欄ボタンの制御処理
            OLS.receiptBtnCtrl();
            // 受け取り方法欄文言の表示処理
            OLS.receiptTextCtrl();
            // 受け取り方法表示
            $("#receiptChgCtrl").show();
        },

        // 年齢選択の処理
        ageStatusChange: function (target, event) {

            // 受け取り方法表示フラグ
            var isReceiptDisplay = true;

            // 直送限定(W2T、タブレット、4Gケータイ)
            // 直送指定
            if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID 
                || ITEM_TYPE_ONLY_HOME.indexOf(arr.itemType) > -1
                || params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME
            ) {
                // 17歳以下の場合
                if ($(target).val() == AGECLASS.B) {
                    $(target).parents("label").removeClass("checked");
                    // 前回の年齢選択状態を設定する
                    $("#ageClass input[value=" + ageClassChoose + "]").prop("checked" , true).parents("label").addClass("checked");
                    // 当サイトでは、ご契約者が17歳以下のお客さまはお申し込みいただけません。
                    alert(g_MsgList["message_alert_underage"]);
                    event.stopImmediatePropagation();
                    // 受け取り方法を非表示
                    isReceiptDisplay = false;
                } else {
                    // 年齢選択状態を保存する
                    ageClassChoose = $("[name=ageClass]:checked").val();
                }
            }

            // 受け取り方法の初期処理
            if (isReceiptDisplay) {
                OLS.receiptCtrlInit();
            }
        },

        // 受け取り方法欄ボタンの制御処理
        receiptBtnCtrl: function () {

            // ボタン表示フラグ
            var displayType = "";
            // ボタン非活性フラグ
            var isDisableBtn = false;
            var ageClassVal = $('input[name=ageClass]:checked').val();

            // iPhone/中古iPhone/iPad または Android(スマートフォン、Google Pixel)
            if (ITEM_TYPE_IPHONE_IPAD.indexOf(arr.itemType) > -1 || ITEM_TYPE_ANDROID.indexOf(arr.itemType) > -1) {

                // 1.iPhone/中古iPhone/iPad かつ iPhone/iPad認定外店舗
                if (ITEM_TYPE_IPHONE_IPAD.indexOf(arr.itemType) > -1 && !authorizedShopFlg) {

                    // ボタン非活性
                    isDisableBtn = true;

                    // 直送固定[2]、O2O固定[3]以外
                    if (params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.HOME && params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.SHOP) {
                        // 17歳以下
                        if (ageClassVal == AGECLASS.B) {
                            // O2Oのみ表示制御
                            displayType = RECEIPT_STYLE_CTRL.SHOP;
                        }
                    } else {

                        // 直送固定[2]またはO2O固定[3]の場合
                        displayType = params.receiptStyleCtrl;
                    }
                }

                // 認定店舗の場合
                if (authorizedShopFlg) {
                    // o2o不可
                    if (!o2oAvailableFlg) {
                        // 直送固定[2]、O2O固定[3]以外
                        if (params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.HOME && params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.SHOP) {
                            // 17歳以下
                            if (ageClassVal == AGECLASS.B) {
                                // O2Oのみ表示制御
                                displayType = RECEIPT_STYLE_CTRL.SHOP;
                                // ボタン非活性
                                isDisableBtn = true;
                            } else {
                                // 直送のみ表示制御
                                displayType = RECEIPT_STYLE_CTRL.HOME;
                            }
                        } else {
    
                            // O2O固定[3]
                            if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP) {
                                // ボタン非活性
                                isDisableBtn = true;
                            }
                            // 直送固定[2]またはO2O固定[3]の場合
                            displayType = params.receiptStyleCtrl;
                        }
                    } else {
                        // O2O可
                        // 直送固定[2]、O2O固定[3]以外
                        if (params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.HOME && params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.SHOP) {
                            // 17歳以下
                            if (ageClassVal == AGECLASS.B) {
                                // O2Oのみ表示制御
                                displayType = RECEIPT_STYLE_CTRL.SHOP;
                            } else {

                                // 受取方法初めて表示時、受取方法がＵＲＬで選択肢を設定して
                                if (receiptFirst) {
                                    // 直送デフォルト[4] 、直送デフォルト(オファーあり)[6]
                                    if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME1 || params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME2) {   
                                        // [自宅等で受け取る]＝デフォルト選択状態
                                        $("#receiptChgCtrl .btnArea input").eq(0).click().click();
                                    } else if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP1 || params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP2) {
                                        // o2oデフォルト[5]、o2oデフォルト(オファーあり)[7]
                                        // [店舗で受け取る]＝デフォルト選択状態
                                        $("#receiptChgCtrl .btnArea input").eq(1).click().click();
                                    }
                                    receiptFirst = false;
                                }

                                // 受取方法メリットリンクを非表示
                                $(".w_open").show();
                            }
                        } else {
    
                            // 直送固定[2]またはO2O固定[3]の場合
                            displayType = params.receiptStyleCtrl;
                        }
                    }
                }

                // ボタン非活性の制御
                if (isDisableBtn) {
                    $("#receiptChgCtrl .btnArea label").removeClass("checked").addClass("disabled");
                    $("#receiptChgCtrl .btnArea input").prop("checked", false).prop("disabled", true);
                }
                // 1つボタン表示
                if (!isEmpty(displayType)) {
                    OLS.hideOther("receiptChgCtrl", displayType);
                    // ボタン文言
                    if (displayType == RECEIPT_STYLE_CTRL.HOME) {
                        // 自宅
                        $("#receiptChgCtrl p.txt").eq(0).html('自宅等でのお受け取りとなります');
                    } else {
                        // 店舗
                        $("#receiptChgCtrl p.txt").eq(1).html('店舗でのお受け取りとなります');
                    }
                }
            }
        },

        // 受け取り方法欄文言の表示処理
        receiptTextCtrl: function () {

            // タイトル
            if ($("#receiptChgCtrl .removeRadio").length == 1) {
                // 1つボタン
                $("#receiptChgCtrl h2").html('受け取り方法');
            } else {
                // 2つボタン
                $("#receiptChgCtrl h2").html('受け取り方法を<br class="sp">選択してください');
            }

            // 説明文言 取扱対象外
            // 1.iPhone/中古iPhone/iPad かつ 認証外店舗
            // 2.iPhone/中古iPhone/iPadまたはAndroid(スマートフォン、Google Pixel) かつ 認定店舗 かつ O2O不可 かつ O2O固定[3]
            // 3.iPhone/中古iPhone/iPadまたはAndroid(スマートフォン、Google Pixel) かつ 認定店舗 かつ O2O不可 かつ 直送固定[2]、O2O固定[3]以外 かつ 17歳以下
            if ((ITEM_TYPE_IPHONE_IPAD.indexOf(arr.itemType) > -1 && !authorizedShopFlg) ||
                ((ITEM_TYPE_IPHONE_IPAD.indexOf(arr.itemType) > -1 || ITEM_TYPE_ANDROID.indexOf(arr.itemType) > -1)
                    && authorizedShopFlg
                    && !o2oAvailableFlg
                    && params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP
                ) ||
                ((ITEM_TYPE_IPHONE_IPAD.indexOf(arr.itemType) > -1 || ITEM_TYPE_ANDROID.indexOf(arr.itemType) > -1)
                    && authorizedShopFlg
                    && !o2oAvailableFlg
                    && params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.HOME && params.receiptStyleCtrl != RECEIPT_STYLE_CTRL.SHOP
                    && $("[name='ageClass']:checked").val() == AGECLASS.B
                )
            ) {
                // 取扱対象外文言を表示
                $("#notHandledShopTxt").show();
            } else {
                $("#notHandledShopTxt").hide();
            }

            // 受け取り方法のボタン文言
            if ($("#receiptChgCtrl .removeRadio").length == 0) {
                // 2つボタン
                $("#receiptChgCtrl p.txt").eq(0).html('自宅等で受け取る');
                $("#receiptChgCtrl p.txt").eq(1).html('店舗で受け取る');
            }

            // O2O対象商材の場合、受け取り方法指定値によりオファー文言の表示を制御する。(2つボタンあり)
            $("#receiptChgCtrl p.notes").hide();
            if (ITEM_TYPE_ONLY_HOME.indexOf(arr.itemType) == -1 && $("#receiptChgCtrl .removeRadio").length == 0) {
                if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME2) {
                    // 受け取り方法が「6」（直送デフォルト　オファーあり）の場合
                    $("#receiptChgCtrl p.notes").eq(0).show();
                    $("#receiptChgCtrl p.notes").eq(1).hide();
                }

                if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP2){
                    // 受け取り方法が「7」（O2Oデフォルト　オファーあり）の場合
                    $("#receiptChgCtrl p.notes").eq(0).hide();
                    $("#receiptChgCtrl p.notes").eq(1).show();
                }
            }
        },

        // 受け取り方選択の制御
        receiptStatusChange: function () {

            // ボタン制御
            if ($("[name='receiptChgCtrl']:checked").length > 0) {
                $('#top #link a.disabled').removeClass('disabled');
            } else {
                $('#top #link a').addClass('disabled');
            }
        },

        /**
         * ラジオ、チェックボックスの初期値
         * @param type
         * @param val
         */
        hideOther: function (type, val) {
            $.each($("input[name=" + type + "]"), function (i, item) {
                if (item.value == val) {
                    $(item).click().click();
                    if (!$(item).parents("label").hasClass("flex12 spFlex12")) {
                        $(item).parents("label").addClass("flex12 spFlex12").removeClass("flex4 spFlex4").removeClass("flex6 spFlex6");
                        $(item).parents("div .btnArea").addClass("removeRadio");
                    }
                } else {
                    $(item).parents("label").hide();
                }
            });
        },

         // 渡した機種選択用パラメータパタンにをチェックする
        isDeviceSelectParams: function () {

            // -----------------
            // 本申込の場合
            // -----------------
            if (!isEmpty(params.sb)) {
                return true;
            }

            // -----------------
            // 通常申込の場合
            // -----------------
            // W2T予約申込の場合
            if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID) {
                // W2T予約申込では店舗情報未指定の場合
                if(isEmpty(params.shopCd)){
                    location.replace(ERROR_URL + '?ec=message_error_request&errorMessage=' + encodeURIComponent(getMessage("message_error_request")));
                    throw new error();
                }
                // 17歳以下はO2O誘導の場合、不正アクセスエラーとする。
                if (params.ageCtrl == AGECLASS.B) {
                    location.replace(ERROR_URL + '?ec=message_error_underage&errorMessage=' + encodeURIComponent(getMessage("message_error_underage")));
                    throw new error();
                }
            }

            // 年齢指定パラメータが設定されている場合、設定値が以下以外の場合に不正アクセスエラーとする。
            if (!isEmpty(params.ageCtrl)) {
                // a：指定なし、b：17歳以下、c：18歳以上
                if (!(params.ageCtrl == AGECLASS.A
                    || params.ageCtrl == AGECLASS.B
                    || params.ageCtrl == AGECLASS.C)) {
                    location.replace(ERROR_URL + '?ec=message_error_underage&errorMessage=' + encodeURIComponent(getMessage("message_error_underage")));
                    throw new error();
                }

                // 17歳以下はO2O誘導のみのため、以下条件に一致する場合は不正アクセスエラーとする。
                if (params.ageCtrl == AGECLASS.B) {
                    // 直送指定での流入
                    // O2O対象外商材(4Gケータイ、タブレット)での申込み
                    if(params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME
                            || ITEM_TYPE_ONLY_HOME.indexOf(arr.itemType) > -1) {
                        location.replace(ERROR_URL + '?ec=message_error_underage&errorMessage=' + encodeURIComponent(getMessage("message_error_underage")));
                        throw new error();
                    }
                }
            }

            // purchaseTypeチェック
            if (!isEmpty(params.purchaseType) && params.purchaseType !== '1' && params.purchaseType !== '48') {
                return false;
            }

            // 機種関連パラメータ（商品カテゴリ、特定グループコード、機種グループコード、機種コード、商品コード）はいずれかの指定必須チェック
            if (isEmpty(params.goodsCd) &&
                    isEmpty(params.itemType) &&
                    isEmpty(params.spGrpCd) &&
                    isEmpty(params.modelGrpCd) &&
                    isEmpty(params.modelId)) {
                return false;
            } else {

                // 指定された機種関連パラメータで機種情報を取得しないの場合
                if (arr.itemType == "" && arr.spGrpCd == "" && arr.modelGrp == "" && arr.modelId == "" && arr.goodsCd == "" ) {
                    // ショップ検索画面へ遷移
                    location.replace(SHOP_SEARCH_URL);
                    throw new error();
                }

            	// 機種関連パラメータ存在チェック
            	if (isEmptyObject(g_goodsStock) || isEmptyObject(g_modelData.itemTypeList)) {
                    // 販売期間外、販売停止フラグON、存在しない
                    location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_param", "errPage")));
                    throw new error();
            	} else {
            		// 商品カテゴリがiPhone、iPad、スマートフォン、タブレット、ケータイ、Google Pixel、中古端末の場合、対象
            		if (g_modelData.itemTypeList[0].itemTypeCd !== "1" && g_modelData.itemTypeList[0].itemTypeCd !== "2"
            			&& g_modelData.itemTypeList[0].itemTypeCd !== "3" && g_modelData.itemTypeList[0].itemTypeCd !== "5"
            			&& g_modelData.itemTypeList[0].itemTypeCd !== "7" && g_modelData.itemTypeList[0].itemTypeCd !== "9"
            			&& g_modelData.itemTypeList[0].itemTypeCd !== "15") {
            			return false;
            		}
                }

                // 取次店舗コードチェック
                if (!isEmpty(params.agencyShopCd) && !checkAgencyShopCd(params.agencyShopCd)) {
                    return false;
                }

                // W2T申込時にo2o可否チェックを行う
                if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID) {
                    denwatenTargetFlgChk(g_modelData, g_goodsStock);
                } else {
                    // 受取方法の整合性チェック
                    var goodsCdArr = getGoodsCdInfo(g_modelData, arr);
                    goodsCdUseChk(goodsCdArr, g_goodsStock, 0);
                }

            	return true;
            }
        },

        // 渡した機種選択用パラメータにをチェックする
        checkDeviceSelectParams: function () {
            if (!OLS.isDeviceSelectParams()) {
                // パラメータをチェックして、NGの場合、エラー画面に遷移する
                location.replace(ERROR_URL + '?errorMessage=' +
                    encodeURIComponent(getMessage("message_error_access", "errPage")));
            }
        },

        // sessionStorage → localStorage
        setSessionStorage: function (key, value) {
            if (!window.localStorage) return;
            try {
                localStorage.setItem(key, value);
            } catch (err) {
                return false;
            }
        },

        // sessionStorage → localStorage
        getSessionStorage: function (key) {
            if (!window.localStorage) return "";
            try {
                return localStorage.getItem(key);
            } catch (err) {
                return false;
            }
        },

        // localStorage情報の個別削除
        singleDeleteStorage: function (key){

            // keyに紐づく値を削除
            try{
                localStorage.removeItem(key);
            } catch (e) {
                return false;
            }

            return true;
        },

        // 初期化localStorage
        clearAllStorage: function () {
            var cookieKey = ["loginType", "contractorReserveNo", "reservationInfo", "inflowSiteCd", "applType", "ageClass", "receiptChgCtrl"];
            for (var index in cookieKey) {
                OLS.singleDeleteStorage(cookieKey[index]);
            }
        },

        // init APIを呼出す
        init: function () {

            // 認証APIから戻る場合、SB契約者と認め
            if (!isEmpty(h.status) && h.status === 'ok') {

                // もう一回init apiを呼び出す。
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'GET',
                    dataType: 'json',
                    url: '/aw/api/v1/mgsInit',
                    contentType: 'application/json',
                    data: {},
                    success: function (data) {
                        // 正常の場合
                        params = {};
                        params.token = data.token;
                        params.itemType = data.item_type;
                        params.spGrpCd = data.sp_grp_cd;
                        params.modelGrpCd = data.model_grp_cd;
                        params.modelId = data.model_id;
                        params.goodsCd = data.goods_code;
                        params.agncyId = data.agency_id;
                        params.shopCd = data.shop_cd;
                        params.purchaseType = data.purchase_type;
                        params.agencyShopCd = data.agency_shop_cd;
                        params.agencyCrewCd = data.agency_crew_cd;
                        params.inflowSiteCd = data.inflowSite_cd;
                        params.receiptStyleCtrl = data.receipt_style_ctrl;
                        params.ageCtrl = data.age_ctrl;
                        params.sb = data.sb;

                        authorizedShopFlg = data.authorized_shop_result == HANDLESHOP_CHECK_RESULT_CODE.unauthorizedShopResult.code ? false : true ;
                        o2oAvailableFlg = data.o2o_available_result == HANDLESHOP_CHECK_RESULT_CODE.o2oUnavailableResult.code ? false : true ;
                        openDate = parseInt(data.open_date);
                        systemDate  = parseInt(data.system_date);
                        token = params.token;
                        isSb = true;
                        var agency_logo_image = data.agency_logo_image;
                        var agency_logo_image_smart_phone = data.agency_logo_image_smart_phone;
                        // 代理店ロゴを表示させる
                        OLS.displayShopLogo(agency_logo_image);

                        // 通常申込の場合
                        if (isEmpty(params.sb)) {
                            // 商品情報を取得する
                            Model.goodsInfo();
                        }
                        // パラメータチェック
                        OLS.checkDeviceSelectParams();

                        // 受取方法メリットリンク初期化
                        OLS.setReceiptLink();

                        // 契約者情報を取得する
                        Login.getMobileCustomerInfo();

                        // ログイン後、ログイン前の画面選択状態をセットする
                        Login.setPageStatus();

                        // 機種の選択画面に受取方法表示制御
                        modelSelectReceiptCtrl();
                    }
                });

            } else if (!isEmpty(h.status) && h.status !== 'ok') {
                // errorを戻る場合
                location.replace(ERROR_URL + '?errorMessage=' +
                    encodeURIComponent(getMessage("message_error_casis", "errPage")));
            } else {
                // 初めて
                params = h;
                // localStorage情報初期化
                OLS.clearAllStorage();

                // 通常申込の場合
                if (isEmpty(params.sb)) {
                    // 商品情報を取得する
                    Model.goodsInfo();
                }
                // パラメータチェック
                OLS.checkDeviceSelectParams();

                // 受取方法メリットリンク初期化
                OLS.setReceiptLink();

                // 初めてinit apiを呼び出す
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'GET',
                    dataType: 'json',
                    url: '/aw/api/v1/mgsInit',
                    contentType: 'application/json',
                    data: {
                        itemType: isEmpty(arr.itemType) ? "" : arr.itemType,
                        spGrpCd: isEmpty(params.spGrpCd) ? "" : params.spGrpCd,
                        modelGrpCd: isEmpty(params.modelGrpCd) ? "" : params.modelGrpCd,
                        modelId: isEmpty(params.modelId) ? "" : params.modelId,
                        goodsCd: isEmpty(params.goodsCd) ? "" : params.goodsCd,
                        agencyId: isEmpty(params.agncyId) ? "" : params.agncyId,
                        purchaseType: isEmpty(params.purchaseType) ? "" : params.purchaseType,
                        agencyShopCd: isEmpty(params.agencyShopCd) ? "" : params.agencyShopCd,
                        agencyCrewCd: isEmpty(params.agencyCrewCd) ? "" : params.agencyCrewCd,
                        inflowSiteCd: isEmpty(params.inflowSiteCd) ? "" : params.inflowSiteCd,
                        receiptStyleCtrl: isEmpty(params.receiptStyleCtrl) ? "" : params.receiptStyleCtrl,
                        shopCd: isEmpty(params.shopCd) ? "" : params.shopCd,
                        ageCtrl: isEmpty(params.ageCtrl) ? "" : params.ageCtrl,
                        sb: isEmpty(params.sb) ? "" : params.sb,
                        reserveNo: isEmpty(params.reserveNo) ? "" : params.reserveNo,
                        dmsn: isEmpty(params.dmsn) ? "" : params.dmsn
                    },
                    success: function (data) {

                        // 正常の場合
                        token = data.token;

                        // テスト公開日時
                        openDate = parseInt(data.open_date);
                        // 業務日付
                        systemDate  = parseInt(data.system_date);
                        // iPhone/iPad認定店舗
                        authorizedShopFlg = data.authorized_shop_result == HANDLESHOP_CHECK_RESULT_CODE.unauthorizedShopResult.code ? false : true ;
                        // o2o対応店舗
                        o2oAvailableFlg = data.o2o_available_result == HANDLESHOP_CHECK_RESULT_CODE.o2oUnavailableResult.code ? false : true ;

                        // 代理店ロゴ
                        var agency_logo_image = data.agency_logo_image;
                        var agency_logo_image_smart_phone = data.agency_logo_image_smart_phone;
                        // 代理店ロゴを表示させる
                        OLS.displayShopLogo(agency_logo_image);
                        // 初期画面の表示
                        OLS.whichPageDisplayForInit();

                    }
                });
            }
        },

        // 予約情報を取得
        getSbReserveInfo: function () {
            if (!isEmpty(OLS.getSessionStorage("reservationInfo"))) {
                OLS.setReserveInfo(JSON.parse(OLS.getSessionStorage("reservationInfo")));
            } else {
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'GET',
                    dataType: 'json',
                    url: '/aw/api/v1/mgsReservation/sb',
                    contentType: 'application/json',
                    data:"reserveNo=" + OLS.getSessionStorage("contractorReserveNo"),
                    success: function (data) {
                        // 予約データを保存する
                        OLS.setSessionStorage("reservationInfo", JSON.stringify(data));
                        // 予約情報を設定
                        OLS.setReserveInfo(data);
                    },
                    beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                        // 業務エラーが発生した場合、ポップアップ表示する前に、前画面に遷移する
                        // 予約本申し込み
                        OLS.proceed('login');
                        // 画面URL設定
                        $("#contractorReserveNo").val(OLS.getSessionStorage("contractorReserveNo")).change();
                    }
                });
            }
        },

        reserveLogin: function () {
            if (!isEmpty(OLS.getSessionStorage("reservationInfo"))) {
                OLS.setReserveInfo(JSON.parse(OLS.getSessionStorage("reservationInfo")));
            } else {
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'POST',
                    dataType: 'json',
                    url: '/aw/api/v1/mgsReservation',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        reservation_number: $('#reserveNo').val(),
                        email_address: $('#reserveEmail').val()
                    }),
                    success: function (data) {
                        // 予約データを保存する
                        OLS.setSessionStorage("reservationInfo", JSON.stringify(data));
                        // 予約情報を設定
                        OLS.setReserveInfo(data);
                    }
                });
            }
        },

        setReserveInfo: function (data) {

            // 予約番号を設定
            $("#contractorReserveNo").val(OLS.getSessionStorage("contractorReserveNo")).change();
            // 正常の場合
            reservationInfo = data;
            // 予約機種コードを設定する
            params.goodsCd = reservationInfo.goods_code;
            // 取次店舗コード
            params.agencyShopCd = reservationInfo.agency_shop_cd;
            // 斡旋クルーコード
            params.agencyCrewCd = reservationInfo.agency_crew_cd;
            // 流入サイト判別コード
            params.inflowSiteCd = reservationInfo.inflow_site_cd;
            // 機種情報を取得
            Model.goodsInfo();
            // 機種選択画面を表示する
            OLS.proceed('deviceSelect');
        },

        // 初期画面の表示
        whichPageDisplayForInit: function () {
            // 本申込
            if (!isEmpty(h.sb)) {
                // SBユーザ
                if (h.sb == 'Y' || h.sb == 'M') {
                    // 認証誘い画面を表示
                    isSb = true;
                    // ご予約番号の設定
                    if (!isEmpty(h.reserveNo)) {
                        // 予約番号チェック
                        $("#contractorReserveNo").val(decodeURIComponent(h.reserveNo)).change();
                        if (!$("#go-to-mySoftbank-login").hasClass("disabled")) {
                            if (h.sb == 'Y') {
                            	Login.jumpToMsnLogin();
                            } else {
                            	Login.jumpToDeviceLogin();
                            }
                            
                        }
                    } else {
                        $("#contractorReserveNo").change();
                    }
                    OLS.proceed('login');
                } else if (h.sb == 'N') {
                    // 本申込
                    isSb = false;
                    OLS.proceed('reserveLogin');
                    // ご予約番号の設定
                    if (!isEmpty(h.reserveNo)) {
                        $("#reserveNo").val(decodeURIComponent(h.reserveNo)).change();
                    }
                } else {
                    // パラメータをチェックして、NGの場合、エラー画面に遷移する
                    location.replace(ERROR_URL + '?errorMessage=' +
                        encodeURIComponent(getMessage("message_error_access", "errPage")));
                }
            } else {
                // 最初の画面
                OLS.proceed('top');
            }
        },

        // top画面において、SBログイン画面に遷移するか、直接機種選択画面に繊維するか決める
        judgeWhereShouldBeLocateForTop: function () {

            // 受取方法チェック
            if (OLS.checkReceipt()) {
                // loadingを表示する
                showLoading();
    
                // 契約状況
                var applType = $('#applType label.checked > div').attr('id');
                if (isSb != undefined && pageController) {
                    var preApplType = isSb ? 'sbmember' : 'nonsbmember';
                    if (applType !== preApplType) {
                        // 画面項目の初期化
                        OLS.pageInit();
                    }
                }
    
                if (applType === 'sbmember') {
                    //SB回線ログイン画面へ遷移
                    isSb = true;
                    Login.jumpToMsnLogin();
                } else if (applType === 'nonsbmember') {
                    //機種選択画面に遷移
                    isSb = false;
                    OLS.proceed('deviceSelect');
                    initDoneFlag = false;
                }

                // 機種の選択画面に受取方法表示制御
                modelSelectReceiptCtrl();
            }
        },

        // 受取方法チェック
        checkReceipt: function () {

            var returnVal = true;

            // 受取方法の整合性チェック
            var goodsCdArr = getGoodsCdInfo(g_modelData, arr);
            returnVal = goodsCdUseChk(goodsCdArr, g_goodsStock, 1);

            // エラーの場合、処理終了
            if (!returnVal) {
                return;
            }

            // sbm以外の代理店IDが指定されている場合
            if(!isEmpty(params.agncyId) && params.agncyId != SOFTBANK_MOBILE) {

                // O2O許可代理店
                var allowAgncyIdO2OPath = getEnviromentInfo(allowAgncyIdO2OList);
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'GET',
                    dataType: 'text',
                    url: allowAgncyIdO2OPath,
                    success: function (o2oData) {
                        // 直送許可代理店
                        var allowAgncyIdDirectPath = getEnviromentInfo(allowAgncyIdDirectList);
                        $.ajax({
                            timeout: 1000 * 30,
                            async: false,
                            cache: false,
                            type: 'GET',
                            dataType: 'text',
                            url: allowAgncyIdDirectPath,
                            success: function (directData) {
                                var o2oDataList=o2oData.split('\n');
                                var homeDataList=directData.split('\n');
                                returnVal = isAgncyIdOk(homeDataList, o2oDataList);
                            }
                        });
                    }
                });
            }
            return returnVal;
        },

        // 準備注意事項画面に遷移前処理
        goToSetup: function () {

            // 商品在庫情報
            var item = pageController.goodsSelectedInfo.goodsStockInfo;
            var nextPageContinueFlg = true;
            // 直送通常、または本申込の場合、分割購入可否チェック（一括を変更ダイアログを表示する。）
            if ((item.salesCondition != SALES_CONDITION_RESERVE && !isO2OorW2T()) || !isEmpty(reservationInfo)) {
                if (isSb && pageController.goodsSelectedInfo.collectionTradeUseVal == '' && pageController.goodsSelectedInfo.installment && accountInfo.c_no_new_kbn == '0') {
                    if ((Utils.contains(CATEGORY_PHONE,pageController.goodsSelectedInfo.goodsKbn) && accountInfo.mobile_phone_ing_kbn == '1') || 
                            (Utils.contains(CATEGORY_TABLET,pageController.goodsSelectedInfo.goodsKbn) && accountInfo.tablet_ing_kbn == '1')) {
                        Utils.openModal(getMessage("popup_goods_number_limit", "popup"), getMessage("popup_button_close", "popup"));
                        nextPageContinueFlg = false;
                    }
                }
            }

            // 下画面へ遷移FLG
            if (nextPageContinueFlg) {
                nextPageContinueFlg = displayImportantOptionAppealDialog();
            }
            if (nextPageContinueFlg) {
                // loadingを表示する
                showLoading();
                // 通常申込予約商品、o2o、W2Tの場合
                if (isEmpty(reservationInfo)
                    && (item.salesCondition == SALES_CONDITION_RESERVE || isO2OorW2T())) {
                    // 新予約遷移のURLの設定
                    // パラメータ
                    var paramStr = [];
                    // 代理店ID
                    var agncyId = 'sbm';
                    if (!isEmpty(params.agncyId)) {
                        agncyId = params.agncyId;
                    }
                    paramStr.push("agncyId="+ agncyId);

                    // 店舗コード
                    if (params.agncyId == 'softbank_denwaten' && checkAgencyShopCd(params.shopCd)) {
                        paramStr.push("shopCd="+ params.shopCd);
                    }

                    // 取次店舗コード
                    if (!isO2OorW2T() && !isEmpty(params.agencyShopCd)
                            && checkAgencyShopCd(params.agencyShopCd)) {
                        paramStr.push("agencyShopCd=" + params.agencyShopCd);
                    }

                    // 商品コード
                    paramStr.push("goodsCd=" + pageController.goodsSelectedInfo.goodsCd);

                    // 申込区分「N」固定
                    paramStr.push("applType=N");

                    // 予約状態フラグ
                    var reserveStsFlg = "0";
                    // 「予約販売」の場合「1:予約」を連携し、「通常販売」の場合「0:予約以外」を連携する。
                    if (item.salesCondition == SALES_CONDITION_RESERVE) {
                        reserveStsFlg = '1'
                    }
                    paramStr.push("reserveStsFlg=" + reserveStsFlg);

                    // 受取方法
                    var receiptStyleCtrl = $("input[name=receiptChgCtrl]:checked").val();
                    // [agncyId]が「softbank_denwaten」の場合、受取方法3:o2o固定
                    if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID) {
                        receiptStyleCtrl = '3';
                    }
                    paramStr.push("receiptStyleCtrl=" + receiptStyleCtrl);

                    // キャッシュキー
                    paramStr.push("cacheKey=" + (new Date).getTime());

                    // 斡旋クルーコード
                    if (!isO2OorW2T() && !isEmpty(params.agencyCrewCd)
                            && checkAgencyCrewCd(params.agencyCrewCd)) {
                        // チェックokの場合、「斡旋クルーコード」を連携する
                        paramStr.push("agencyCrewCd=" + params.agencyCrewCd);
                    }

                    // 流入サイト判別コード
                    if (checkInflowSiteCd(params.inflowSiteCd)) {
                        // チェックokの場合、「流入サイト判別コード」を連携する
                        paramStr.push("inflowSiteCd=" + params.inflowSiteCd);
                    }

                    // msn
                    if (accountInfo != undefined) {
                        // 回線msnログイン：msnを連携
                        // 機種契約番号ログイン：機種契約番号を連携
                        paramStr.push("msn=" + accountInfo.msn);
                    }

                    // 販売種別「1」固定
                    paramStr.push("salesType=" + '1');

                    // 支払回数
                    if (isO2OorW2T()) {
                        if(pageController.goodsSelectedInfo.installment){
                            paramStr.push("purchaseType=" + '48');
                        } else {
                            paramStr.push("purchaseType=" + '1');
                        }
                    }

                    // 機種契約番号
                    if ($('#entryCollectionTrade').is(':visible') && $('input[name=privilegeUseAskSelect]:checked').val() == '1') {
                        // トクするサポート、トクするサポート＋の権利行使を行う機種の機種契約番号
                        var mcn = pageController.goodsSelectedInfo.olsCollectionTradeInInfo[pageController.goodsSelectedInfo.collectionTradeIdx].deviceMsn;
                        paramStr.push("mcn=" + mcn);
                    }

                    // ログインタイプ
                    if (!isO2OorW2T() && accountInfo != undefined) {
                        // 直送予約申込時、ログインタイプを連携する
                        // 0:回線MSN
                        // 1:機種契約番号
                        paramStr.push("loginType=" + accountInfo.login_type);
                    }

                    // 遷移前にloadingを非表示
                    hideLoading();
                    // 新予約画面へ遷移する
                    location.href = OLS_APPLY_URL + paramStr.join('&');
                    return;
                } else {
                    // あんしん保証パック表示制御
                    if($('.optionTopTitle .checked').length > 0){
                        if ($('#ptionDetailDiv').css('display') != 'none' && $('#optionDetailDiv .checked').length > 0) {
                            safePackDetailCheckedCd = $('#optionDetailDiv .checked').find('input[name^=afterServiceItemCd_optionSelect]').val();
                        }
                        safePackCheckedFlg = true;
                        safePackItemCd = pageController.goodsSelectedInfo.goodsCd;
                        // タブレットとケータイの場合
                        if(pageController.goodsSelectedInfo.itemType === '5' || pageController.goodsSelectedInfo.itemType === '7'){
                            if ($('#safePack #option1CheckBox').hasClass('checked')) {
                                safePackDetailCheckedCd = $('input[name=afterServiceItemCd_optionSelect1]').val();
                            } else if ($('#safePack #option2CheckBox').hasClass('checked')){
                                safePackDetailCheckedCd = $('input[name=afterServiceItemCd_optionSelect2]').val();
                            }
                        }
                    }else{
                        safePackCheckedFlg = false;
                        safePackItemCd = pageController.goodsSelectedInfo.goodsCd;
                    }
                    var itemPrice = '';
                    var installmentPrice = '';
                    var installmentPrice2 = '';
                    if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg) {
                        itemPrice = String(pageController.goodsSelectedInfo.installment_total + pageController.goodsSelectedInfo.cmpn1DscPrAl);
                        installmentPrice = String(pageController.goodsSelectedInfo.installment_price + pageController.goodsSelectedInfo.cmpn1DscPr);
                    } else {
                        itemPrice = String(pageController.goodsSelectedInfo.installment_total);
                        installmentPrice = String(pageController.goodsSelectedInfo.installment_price);
                    }
                    // 前後半金額差異あり
                    if (pageController.goodsSelectedInfo.buyStylePriceDifFlg) {
                        installmentPrice2 = String(pageController.goodsSelectedInfo.installment_price25);
                    } else {
                        installmentPrice2 = String(pageController.goodsSelectedInfo.installment_price);
                    }
                    var inputList = {
                            goodsCd: pageController.goodsSelectedInfo.goodsCd,
                            installment48: pageController.goodsSelectedInfo.installment,
                            studentDiscountUseFlg : pageController.goodsSelectedInfo.studentDiscountSelectedFlg,
                            itemPrice : itemPrice,
                            installmentPrice : installmentPrice,
                            installmentPrice2 : installmentPrice2
                    };
                    // 機種選択画面で次の画面へ遷移前チェック apiを呼び出す
                    $.ajax({
                        timeout: 1000 * 30,
                        async: false,
                        cache: false,
                        type: 'POST',
                        dataType: 'json',
                        url: '/aw/api/v1/mobileGoodsInfoCheck',
                        contentType: 'application/json',
                        data: JSON.stringify(inputList),
                        success: function (data) {
                            // ヘッダリストの表示制御
                            if (!isSb) {
                                OLS.proceed('setup');
                                $('.listFlow_pay').show();
                                $('.listFlow_setup').show();
                                $('.listFlow_identity').show();
                                $('body').addClass('PhoneNotSb');
                            } else {
                                OLS.goToCustomerInfoEntry();
                                $('.listFlow_pay').hide();
                                $('.listFlow_setup').hide();
                                if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg) {
                                    $('.listFlow_identity').show();
                                    $('body').addClass('PhoneNotSb');
                                } else {
                                    $('.listFlow_identity').hide();
                                    $('body').removeClass('PhoneNotSb');
                                }
                            }
                        }
                    });
                }
            }
         },

        // 入力画面に遷移前処理
        goToCustomerInfoEntry: function () {

            // loadingを表示する
            showLoading();

            // あんしん保証パック表示制御
            if($('.optionTopTitle .checked').length > 0){
                if ($('#ptionDetailDiv').css('display') != 'none' && $('#optionDetailDiv .checked').length > 0) {
                    safePackDetailCheckedCd = $('#optionDetailDiv .checked').find('input[name^=afterServiceItemCd_optionSelect]').val();
                }
                safePackCheckedFlg = true;
                safePackItemCd = pageController.goodsSelectedInfo.goodsCd;
                // タブレットとケータイの場合
                if(pageController.goodsSelectedInfo.itemType === '5' || pageController.goodsSelectedInfo.itemType === '7'){
                    if ($('#safePack #option1CheckBox').hasClass('checked')) {
                        safePackDetailCheckedCd = $('input[name=afterServiceItemCd_optionSelect1]').val();
                    } else if ($('#safePack #option2CheckBox').hasClass('checked')){
                        safePackDetailCheckedCd = $('input[name=afterServiceItemCd_optionSelect2]').val();
                    }
                }
            }else{
                safePackCheckedFlg = false;
                safePackItemCd = pageController.goodsSelectedInfo.goodsCd;
            }

            $('body').attr('data-isSb', isSb);

            // 顧客情報入力画面各項目を設定する
            if (isSb) {

                // 初めて
                if (isEmpty($('#sbCustomerInfoEntry').attr('data-sbCustomerInfoEntry-isFirst'))) {

                    $('#sbContractName').text(formatPhoneNum(accountInfo.msn, '3-4-4'));
                    $('#sbContractMsn').text('電話連絡先：' + formatPhoneNum(accountInfo.telephone_number, '3-4-4'));
                    // 予約本申込みの場合
                    if (!isEmpty(reservationInfo)) {
                        // Eメールアドレス 設定要？
                        $('#sbCustomerInfoEntry #contactToEmailAddress').val(reservationInfo.email_address).change();
                        $('#sbCustomerInfoEntry #contactToEmailAddressForCheck').val(reservationInfo.email_address).change();
                        // バリデーションチェックflgを設定
                        $('#SbCustomerInfoEntry #go-to-delivery').toggleClass('disabled', preventProceed(SbCustomerInfoEntry));
                    }
                    $('#sbCustomerInfoEntry').attr('data-sbCustomerInfoEntry-isFirst', 'true');
                }

                // 契約中の番号の文言変更
                if (isTerminal) {
                    // 機種契約番号ログイン
                    $('#sbContractorUseTelNo p').text('契約中の機種契約番号');
                } else {
                    // 回線番号ログイン
                    $('#sbContractorUseTelNo p').text('契約中の電話番号');
                }

                // 職業欄
                // 権利行使する、特典を利用する
                if(viewContactJob()){
                    $("#sbJobCdChecked").show();
                    //色彩の変更
                    $("#sbContractorUseTelNo").removeClass('bgWh').addClass('bgGry');
                    // 職業のvalid状態初期化
                    resetVaildValue("sbJobCd");
                    // 職業のvalid状態更新
                    if ($('#sbJobCd').val()) {
                        $('#sbJobCd').change();
                    }
                }else{
                    $("#sbJobCdChecked").hide();
                    $('.sbContractorOffice').hide();
                    //色彩の変更
                    $("#sbContractorUseTelNo").removeClass('bgGry').addClass('bgWh');
                    // バリデーションチェック
                    $("#sbJobCd option[value='']").prop("selected", true).change();
                }

                // キャンペーン対象者欄
                // 学割利用の場合
                if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg) {

                    // キャンペーン対象者欄の年表示範囲を5から30年前まで表示とする
                    var calendarType = '1';
                    // 年プルダウンを設定する
                    if (isEmpty($('#sbCustomerInfoEntry').attr('data-sbUserInfoEntry-isFirst'))) {
                        makeJPNYearSelect($('#sbCustomerInfoEntry #sbUserBirthDateYear'),calendarType);
                        $('#sbCustomerInfoEntry').attr('data-sbUserInfoEntry-isFirst', 'true');
                    }

                    // キャンペーン対象者入力欄表示
                    $('#sbUserInfo').show();

                    // キャンペーン対象者各情報のvalid状態初期化
                    $('#sbUserInfo .userInfoArea input, #sbUserInfo .userInfoArea select').each(function(){
                        var keyId = $(this).attr('id');
                        // valid状態更新
                        resetVaildValue(keyId);
                    });
                    // キャンペーン対象者各情報のvalid状態更新
                    $('#sbUserInfo .userInfoArea input, #sbUserInfo .userInfoArea select').each(function(){
                        if ($(this).attr('name') == 'sbUserSexCd_customerInfo') {
                            // 性別
                            if ($("[name=sbUserSexCd_customerInfo]:checked").val()) {
                                $("#sbUserSexCdMale").change();
                            }
                        } else {
                            // 姓名、生年月日
                            if ($(this).val()) {
                                $(this).change();
                            }
                        }
                    });
                } else {
                    // キャンペーン対象者入力欄非表示
                    $('#sbUserInfo').hide();
                    // キャンペーン対象者各情報のvalid状態 trueに設定
                    $('#sbUserInfo .userInfoArea input, #sbUserInfo .userInfoArea select').each(function(){
                        var keyId = $(this).attr('id');
                        SbCustomerInfoEntry.validated[keyId].valid = true;
                    });
                }
                // 次へボタン状態更新
                $('#sbCustomerInfoEntry #go-to-delivery').toggleClass('disabled', preventProceed(SbCustomerInfoEntry));
                OLS.proceed('sbCustomerInfoEntry');

            } else {
                // 国籍と職業欄
                // 分割の場合
                var lastJobInstallmentCd = $('#nonSbJobCd').val()
                var jobInstallmentOption = '';
                if (viewContactJob()) {
                    jobInstallmentOption = `<option value="">選択してください</option>
                    <option value="01">会社員</option>
                    <option value="02">公務員</option>
                    <option value="03">自営業</option>
                    <option value="04">専業主婦</option>
                    <option value="05">学生</option>
                    <option value="99">その他</option>`;
                } else {
                    jobInstallmentOption = `<option value>選択してください</option>
                    <option value="06">会社員/自営業</option>
                    <option value="07">共働き</option>
                    <option value="04">専業主婦</option>
                    <option value="08">学生/その他（同居）</option>
                    <option value="09">学生/その他（別居）</option>`;
                }
                $('select[name=nonSbJobCd_customerInfo]').html(jobInstallmentOption);
                if (viewContactJob() || pageController.goodsSelectedInfo.installment) {
                    $("#nonSbJobCdChecked").show();
                    // 職業のvalid状態初期化
                    resetVaildValue("nonSbJobCd");
                    // 職業のvalid状態更新
                    if (lastJobInstallmentCd) {
                        $('#nonSbJobCd option[value="' + lastJobInstallmentCd + '"]').prop("selected", true).change();
                    }
                } else {
                    $('.nonSbContractorOffice').hide();
                    $("#nonSbJobCdChecked").hide();
                    $("#nonSbJobCd option[value='']").prop("selected", true).change();
                }

                if (pageController.goodsSelectedInfo.installment) {
                    $("#nationalityCdChecked").show();
                    //色彩の変更
                    $("#nonSbAddressChecked").addClass('bgGry');
                    $("#nonSbTelNoChecked").addClass('nonSbCustWhiteBg');
                    $("#nonSbEmailAddressChecked").addClass('bgGry');
                    $("#nonSbAddressChecked").removeClass('nonSbCustWhiteBg');
                    $("#nonSbTelNoChecked").removeClass('bgGry');
                    $("#nonSbEmailAddressChecked").removeClass('nonSbCustWhiteBg');
                    // 国籍のvalid状態初期化
                    resetVaildValue("nationalityCd");
                    // 国籍のvalid状態更新
                    if ($('#nationalityCd').val()) {
                        $('#nationalityCd').change();
                    }
                }else{
                    $("#nationalityCdChecked").hide();
                    //色彩の変更
                    $("#nonSbAddressChecked").removeClass('bgGry');
                    $("#nonSbTelNoChecked").removeClass('nonSbCustWhiteBg');
                    $("#nonSbEmailAddressChecked").removeClass('bgGry');
                    $("#nonSbAddressChecked").addClass('nonSbCustWhiteBg');
                    $("#nonSbTelNoChecked").addClass('bgGry');
                    $("#nonSbEmailAddressChecked").addClass('nonSbCustWhiteBg');
                    // バリデーションチェック
                    $("#nationalityCd option[value='']").prop("selected", true).change();
                }
                $('.addressNotice').show();

                if (isEmpty($('#nonSbCustomerInfoEntry').attr('data-nonSbCustomerInfoEntry-isFirst'))) {
                    // 年プルダウンを設定する
                    makeJPNYearSelect($('#nonSbCustomerInfoEntry #birthDateYear'),'');

                    // 予約本申込みの場合
                    if (!isEmpty(reservationInfo)) {
                        // 氏名を設定
                        $('#nonSbCustomerInfoEntry #contractorNameSei').val(reservationInfo.name_sei).change();
                        $('#nonSbCustomerInfoEntry #contractorNameMei').val(reservationInfo.name_mei).change();
                        $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val(reservationInfo.name_sei_kana).change();
                        $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val(reservationInfo.name_mei_kana).change();
                        // 生年月日を設定
                        $("#nonSbCustomerInfoEntry #birthDateYear option[value='" + reservationInfo.birthdate_year + "']").prop("selected", true).change();
                        $("#nonSbCustomerInfoEntry #birthDateMonth option[value='" + reservationInfo.birthdate_month + "']").prop("selected", true).change();
                        $("#nonSbCustomerInfoEntry #birthDateDay option[value='" + reservationInfo.birthdate_date + "']").prop("selected", true).change();
                        // 性別
                        $("#nonSbCustomerInfoEntry [name='sexCd_customerInfo'][value='" + reservationInfo.gender + "']").click().change();
                        // 住所
                        $('#nonSbCustomerInfoEntry #contractorZipCd').val(reservationInfo.post_code).change();
                        $('#nonSbCustomerInfoEntry #addSearchFromZip').click();
                        $('#nonSbCustomerInfoEntry #contractorAddressGaiku').val('').change();
                        // 連絡先電話番号
                        $('#nonSbCustomerInfoEntry #contractorTelNo').val(reservationInfo.tel_no).change();
                        // Eメールアドレス 設定要？
                        $('#nonSbCustomerInfoEntry #contactToEmailAddress').val($('#reserveEmail').val());
                        $('#nonSbCustomerInfoEntry #contactToEmailAddressForCheck').val($('#reserveEmail').val()).change();
                        // バリデーションチェックflgを設定
                        validateItem(NonSbCustomerInfoEntry, $('#nonSbCustomerInfoEntry #contractorAddressArea'));
                        validateItem(NonSbCustomerInfoEntry, $('#nonSbCustomerInfoEntry #contractorAddressGaiku'));
                    }

                    $('#nonSbCustomerInfoEntry').attr('data-nonSbCustomerInfoEntry-isFirst', 'true');
                }

                // キャンペーン対象者欄
                // 学割利用の場合
                if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg) {
                    // キャンペーン対象者欄の年表示範囲を5から30年前まで表示とする
                    var calendarType = '1';
                    // 年プルダウンを設定する
                    if (isEmpty($('#nonSbCustomerInfoEntry').attr('data-nonSbUserInfoEntry-isFirst'))) {
                        makeJPNYearSelect($('#nonSbCustomerInfoEntry #nonSbUserBirthDateYear'),calendarType);
                        $('#nonSbCustomerInfoEntry').attr('data-nonSbUserInfoEntry-isFirst', 'true');
                    }
                    // キャンペーン対象者入力欄表示
                    $("#nonSbUserContractorDiffirent").change();
                    // キャンペーン対象者入力欄表示
                    $('#nonSbUserInfo').show();
                } else {
                    // キャンペーン対象者入力欄非表示
                    $('#nonSbUserInfo').hide();
                    $("#nonSbUserContractorDiffirent").prop("checked", false).change();
                    $("#nonSbUserContractorDiffirent").parent().parent().removeClass("checked");
                }

                // 次へボタン状態更新
                $('#btn-to-delivery-pay').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
                OLS.proceed('nonSbCustomerInfoEntry');
            }
        },

        // 配送情報画面に遷移前処理
        goToDelivery: function () {
            // 入力画面バリデーションチェック
            if (!viewContractorInfoCheck()) {
                return;
            }

            var nextPageFlg = true;
            if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg) {
                var inputList = {
                        // キャンペーン対象者姓
                        user_last_name: $('#sbCustomerInfoEntry #sbUserNameSei').val(),

                        // キャンペーン対象者名
                        user_first_name: $('#sbCustomerInfoEntry #sbUserNameMei').val(),

                        // キャンペーン対象者姓(カナ)
                        user_last_name_kana: $('#sbCustomerInfoEntry #sbUserNameSeiKana').val(),

                        // キャンペーン対象者名(カナ)
                        user_first_name_kana: $('#sbCustomerInfoEntry #sbUserNameMeiKana').val(),

                        // キャンペーン対象者生年月日
                        user_birthday: $('#sbCustomerInfoEntry #sbUserBirthDateYear').val()
                                        + $('#sbCustomerInfoEntry #sbUserBirthDateMonth').val()
                                        + $('#sbCustomerInfoEntry #sbUserBirthDateDay').val()
                };
                // 使用者情報チェック apiを呼び出す
                $.ajax({
                  timeout: 1000 * 30,
                  async: false,
                  cache: false,
                  type: 'POST',
                  dataType: 'json',
                  url: '/aw/api/v1/studentDiscount',
                  contentType: 'application/json',
                  data: JSON.stringify(inputList),
                  success: function (data) {
                      // 正常の場合、下画面へ遷移
                      nextPageFlg = true;
                  },
                  beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                      // 正常以外の場合、下画面へ遷移しない
                      nextPageFlg = false;
                  }
                });
            }

            if(nextPageFlg){
                // loadingを表示する
                showLoading();
                // 「契約住所に配送する」と「別住所への配送を希望する」選択肢を表示する
                $('#delivery #send-to-display').hide();
                $('#delivery #send-to-display-notice').hide();
                $('#delivery #send-to-form').show();
                // SBログインかつ一括の場合
                if (pageController.isShowCreditForSb()) {
                    // 年のプルダウンを生成
                    Utils.makeYearSelect('#creditCardTermYear');
                    // 決済方法を表示
                    $('#selectPay').show();
                } else {
                    // 決済方法を非表示
                    $('#selectPay').hide();
                }
                // バリデーションチェック
                $('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
                    validateItem(Delivery, $(this), true);
                });
                $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
                OLS.proceed('delivery');

                // 出荷元倉庫発報対応、契約者住所不備 の場合
                if (accountInfo.address_hand_input_flag) {
                    $('input[name="deliveryToAddressKbn_customerInfo"]').prop('checked', true);
                }
            }
        },

        // 支払い情報画面に遷移前処理
        goToPay: function () {
            // 入力画面バリデーションチェック
            if (!viewContractorInfoCheck()) {
                return;
            }

            var nextPageFlg = true;
            if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg) {
                var inputList;
                // 契約者と異なる
                if ($("input[name='nonSbUserContractor_customerInfo']").is(':checked')) {
                    inputList = {
                            // キャンペーン対象者姓
                            user_last_name: $('#nonSbCustomerInfoEntry #nonSbUserNameSei').val(),

                            // キャンペーン対象者名
                            user_first_name: $('#nonSbCustomerInfoEntry #nonSbUserNameMei').val(),

                            // キャンペーン対象者姓(カナ)
                            user_last_name_kana: $('#nonSbCustomerInfoEntry #nonSbUserNameSeiKana').val(),

                            // キャンペーン対象者名(カナ)
                            user_first_name_kana: $('#nonSbCustomerInfoEntry #nonSbUserNameMeiKana').val(),

                            // キャンペーン対象者生年月日
                            user_birthday: $('#nonSbCustomerInfoEntry #nonSbUserBirthDateYear').val()
                                            + $('#nonSbCustomerInfoEntry #nonSbUserBirthDateMonth').val()
                                            + $('#nonSbCustomerInfoEntry #nonSbUserBirthDateDay').val()
                    };
                } else {
                    inputList = {
                            // キャンペーン対象者姓
                            user_last_name: $('#nonSbCustomerInfoEntry #contractorNameSei').val(),

                            // キャンペーン対象者名
                            user_first_name: $('#nonSbCustomerInfoEntry #contractorNameMei').val(),

                            // キャンペーン対象者姓(カナ)
                            user_last_name_kana: $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val(),

                            // キャンペーン対象者名(カナ)
                            user_first_name_kana: $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val(),

                            // キャンペーン対象者生年月日
                            user_birthday: $('#nonSbCustomerInfoEntry #birthDateYear').val()
                                            + $('#nonSbCustomerInfoEntry #birthDateMonth').val()
                                            + $('#nonSbCustomerInfoEntry #birthDateDay').val()
                    };
                }
                // 使用者情報チェック apiを呼び出す
                $.ajax({
                  timeout: 1000 * 30,
                  async: false,
                  cache: false,
                  type: 'POST',
                  dataType: 'json',
                  url: '/aw/api/v1/studentDiscount',
                  contentType: 'application/json',
                  data: JSON.stringify(inputList),
                  success: function (data) {
                      // 正常の場合、下画面へ遷移
                      nextPageFlg = true;
                  },
                  beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                      // 正常以外の場合、下画面へ遷移しない
                      nextPageFlg = false;
                  }
                });
            }

            if(nextPageFlg){
                // loadingを表示する
                showLoading();

            if(pageController.goodsSelectedInfo.installment || $('#safePack #optionTopCheckBox').hasClass('checked')){
                    $('.creditOnly').html('機種代金と月々のお支払いに利用する<br>クレジット情報を入力ください。');
            }else if(!pageController.goodsSelectedInfo.installment && !$('#safePack #optionTopCheckBox').hasClass('checked')){
                    $('.creditOnly').html('機種代金のお支払いに利用する<br>クレジット情報を入力ください。');
                }
                // クレジットカード有効期限のカレンダーを生成。
                Utils.makeYearSelect('#billCreditCardTermYear');
                // クレジットカードのセキュリティコードの？リンク
                if ($("#billSecurityCodePopBtn")) {
                    var srcUrl = getEnviromentInfo(securityCodeList);
                    $("#billSecurityCodePopBtn").load(srcUrl);
                }
                OLS.proceed('pay');
            }
        },

        // 支払い情報/配送画面に遷移
        backToPayOrDelivery: function () {
            if ($("#payStyleChange").hasClass("cashDelivery")) {
                OLS.proceed('delivery');
            } else {
                OLS.proceed('pay');
            }
        },

        // 同意画面に遷移前処理
        goToAgreement: function () {

            var nextPageFlg = true;
            if (!isSb) {

                var inputList = {
                        // ご契約者名フリガナ
                        contractor_name_sei_kana: $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val(),

                        // ご契約者名フリガナ
                        contractor_name_mei_kana: $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val(),

                        // 商品代金のお支払い方法
                        pay_style: '1',

                        // カード会社
                        credit_card_company_id: $('#billCreditCardCompanyId').val(),

                        // カード有効期限
                        credit_card_term: $('#billCreditCardTermMonth').val() + $('#billCreditCardTermYear').val(),

                        // カード名義（カタカナ）
                        credit_card_owner_sei: $('#billCreditCardOwnerSeiKana').val(),

                        // カード名義（カタカナ）
                        credit_card_owner_mei: $('#billCreditCardOwnerMeiKana').val()
                };
                // 支払い情報画面 apiを呼び出す
                $.ajax({
                  timeout: 1000 * 30,
                  async: false,
                  cache: false,
                  type: 'POST',
                  dataType: 'json',
                  url: '/aw/api/v1/pay',
                  contentType: 'application/json',
                  data: JSON.stringify(inputList),
                  success: function (data) {
                      // 正常の場合、下画面へ遷移
                      nextPageFlg = true;
                  },
                  beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                      // 正常以外の場合、下画面へ遷移しない
                      nextPageFlg = false;
                  }
                });
            }else{
                // 別住所への配送を希望する
                if ($("#otherAddress").is(":checked")) {
                    // バリデーションチェック 住所入力欄の郵便番号検索後のプルダウン未選択時
                    if ($('#sendToAddressArea option:selected').val() == '0') {
                        Utils.openModal(getMessage("popup_address_pulldown_no_select", "popup"), getMessage("popup_button_close", "popup"));
                        return;
                    }

                    // バリデーションチェック 都道府県からの住所の合計文字数を60以下にする
                    var address1Length = addressInfo[$('#sendToAddressArea option:selected').val()].length;
                    var address2Length = $('#delivery #sendToAddressGaiku').val().length;
                    var address3Length = $('#delivery #sendToAddressIncidental').val().length;
                    if (address1Length + address2Length + address3Length > 60) {
                        Utils.openModal(getMessage("popup_address_total_size", "popup"), getMessage("popup_button_close", "popup"));
                        nextPageFlg = false;
                    }
                }

                if (pageController.isShowCreditForSb() && $('#payStyle02').is(':checked')) {
                    var inputList = {
                            // ご契約者名フリガナ
                            contractor_name_sei_kana: accountInfo.last_name_kana,
                            // ご契約者名フリガナ
                            contractor_name_mei_kana: accountInfo.first_name_kana,
                            // 商品代金のお支払い方法
                            pay_style: '1',
                            // カード会社
                            credit_card_company_id: $('#creditCardCompanyId').val(),
                            // カード有効期限
                            credit_card_term: $('#creditCardTermMonth').val() + $('#creditCardTermYear').val(),
                            // カード名義（カタカナ）
                            credit_card_owner_sei: $('#creditCardOwnerSei').val(),
                            // カード名義（カタカナ）
                            credit_card_owner_mei: $('#creditCardOwnerMei').val()
                    };
                    // 支払い情報画面 apiを呼び出す
                    $.ajax({
                      timeout: 1000 * 30,
                      async: false,
                      cache: false,
                      type: 'POST',
                      dataType: 'json',
                      url: '/aw/api/v1/pay',
                      contentType: 'application/json',
                      data: JSON.stringify(inputList),
                      success: function (data) {
                          // 正常の場合、下画面へ遷移
                          // nothing
                      },
                      beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                          // 正常以外の場合、下画面へ遷移しない
                          nextPageFlg = false;
                      }
                    });
                }
            }

            if(nextPageFlg){
                // loadingを表示する
                showLoading();

                var agreeDiv = $('#installmentBuyContractAgree');
                if (pageController.goodsSelectedInfo.installment) {
                    agreeDiv.insertBefore($('#personalInfoAgree'));
                    agreeDiv.show();
                } else {
                    agreeDiv.hide();
                }

                // 新トクするサポート注意事項表示制御
                if ($('#tokusapoPlusDiv').css('display') !== 'none') {
                    $('#newTokusuruSupport').show();
                } else {
                    $('#newTokusuruSupport').hide();
                }

                // 下取りに関する同意事項表示制御
                if ($('#entryCollectionTrade').css('display') === 'block' && $('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
                    && isTradeInProgram($('input[name="privilegeUseSelect"]:checked').val().split(',')[0])){
                    $('#campaignInfo').show();
                } else {
                    $('#campaignInfo').hide();
                }

                // トクするサポート特典利用に関する注意事項
                if ($('#entryCollectionTrade').css('display') === 'block' && $('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
                    && $('input[name="privilegeUseSelect"]:checked').val().split(',')[0] === TOKUSURU_SUPPORT_JUDGE_KBN.tokusuruSupport
                        && ($('input[name="privilegeUseSelect"]:checked').val().split(',')[1] === TOKUSURU_SUPPORT_USE_CODE_LIST.TokusuruSupport_UseOfUpgradeInOneYearCampaign
                                || $('input[name="privilegeUseSelect"]:checked').val().split(',')[1] === TOKUSURU_SUPPORT_USE_CODE_LIST.TokusuruSupport_Use)){
                    // 「トクするサポートの解約」選択時は表示しない
                    $('#tokusuruSupportInfo').show();
                } else {
                    $('#tokusuruSupportInfo').hide();
                }

                // トクするサポート＋特典利用に関する注意事項
                if ($('#entryCollectionTrade').css('display') === 'block' && $('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
                    && $('input[name="privilegeUseSelect"]:checked').val().split(',')[0] === TOKUSURU_SUPPORT_JUDGE_KBN.tokusuruSupportPlus){
                    $('#tokusuruSupportPlusInfo').show();
                } else {
                    $('#tokusuruSupportPlusInfo').hide();
                }

                // 新トクするサポート特典利用に関する注意事項
                if ($('#entryCollectionTrade').css('display') === 'block' && $('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
                    && $('input[name="privilegeUseSelect"]:checked').val().split(',')[0] === TOKUSURU_SUPPORT_JUDGE_KBN.newTokusuruSupport){
                    $('#newTokusuruSupportInfo').show();
                } else {
                    $('#newTokusuruSupportInfo').hide();
                }

                // あんしん保証パックネクスト選択の場合、「あんしん保証パックネクストに関する注意事項」表示する
                if ($("#afterServiceCd").prop("checked")
                		&& $('#safePack').css('display') != 'none'
                		&& $('#afterServiceCd').val() === '017') {
	
	                // 商品コードの設定
                    var serchGoodsCd = '';
                    if (!isEmpty(reservationInfo)) {
                        serchGoodsCd = reservationInfo.goods_code;
                    } else {
                        serchGoodsCd = pageController.goodsSelectedInfo.goodsCd;
                    }
                    var strTop = serchGoodsCd.slice(0, 2);
                    var strEnd = serchGoodsCd.slice(3, 6);
                    serchGoodsCd = strTop + "A" + strEnd;
                    
                    // あんしん保証パック」の表示条件を「商品対応サービス紐付マスタ.機種中分類[0072]の場合
                    if (pageController.goodsItmSvcList[serchGoodsCd]['1000'] === 'modelMiddleCategoryGoogle') {
                        
                        // URLを設定する GooglePiexl
                        $("#safePackNextInfoHtml").prop("src", getEnviromentInfo(safePackNextAgreePixelList));
                    } else {
                        
                        // URLを設定する シャープ
                        $("#safePackNextInfoHtml").prop("src", getEnviromentInfo(safePackNextAgreeShList));
                    }
                	$('#safePackNextAgree').show();
                } else {
                    $('#safePackNextAgree').hide();
                }

                agreeCtl.agreeLoad();
                OLS.proceed('agreement');
            }
        },

        goToConfirm: function () {
            if (!isSb || (isSb && pageController.goodsSelectedInfo.studentDiscountSelectedFlg)) {
                $('#go-to-complete span').html("申し込み内容を確定して、次に進む");
            } else {
                $('#go-to-complete span').html("申し込み内容を確定する");
            }
            OLS.proceed('confirm');
        },

        goToComplete: function () {
            // 申込登録リクエスト情報作成
            applyRegistInfoCreate();

            // 二重送信を防ぐ実装
            $("#go-to-complete").addClass("disabled");

            // loadingを表示する
            showLoading();

            // loadingを書けるように
            setTimeout(function () {
                // 登録前の禁則文字変換
                applyRegistInfo.address_block = replaceForbidden(applyRegistInfo.address_block);
                applyRegistInfo.address_incidental = replaceForbidden(applyRegistInfo.address_incidental);
                applyRegistInfo.first_name = replaceForbidden(applyRegistInfo.first_name);
                applyRegistInfo.first_name_kana = replaceForbidden(applyRegistInfo.first_name_kana);
                applyRegistInfo.last_name = replaceForbidden(applyRegistInfo.last_name);
                applyRegistInfo.last_name_kana = replaceForbidden(applyRegistInfo.last_name_kana);

                // 流入サイト判別コード
                applyRegistInfo.inflow_site_cd = isEmpty(params.inflowSiteCd) ? null : params.inflowSiteCd;
                // 斡旋クルーコード
                applyRegistInfo.agency_crew_cd = isEmpty(params.agencyCrewCd) ? null : params.agencyCrewCd;

                if (!isSb) {
                    OLS.proceed('identity');

                    // 本人確認書類画面の画像認証
                    $('#kaptchaImg').attr('src', '/aw/Kaptcha.jpg?v=' + new Date().getTime());
                    $('#kaptchaCode').val('');
                    $('#kaptchaAuth').show();
                    // 選択した画像を送るボタンを非活性になる
                    $("#identity-go-to-complete").addClass("disabled");
                    // キャンペーン対象者本人確認書類選択プルダウンを設定する
                    OLS.makePulldown();
                } else if (isSb && pageController.goodsSelectedInfo.studentDiscountSelectedFlg) {
                    OLS.proceed('identity');
                    $('#kaptchaAuth').hide();
                    // キャンペーン対象者本人確認書類選択プルダウンを設定する
                    OLS.makePulldown();
                } else {
                    var sbpsCompleteFlg = false;

                    // SBかつ、支払方法がクレカの場合かつ、購入方法が割賦以外（一括・通常）の場合
                    if (pageController.isShowCreditForSb() && $('#payStyle02').is(':checked')) {
                        // クレジットカード
                        var creditCardNo = $("input[name='creditCardNo_customerInfo']").val();

                        // セキュリティコード
                        var creditCardSecurityCode = $("#securityCode").val();

                        var cardUseTermMonth = $("select[name='creditCardTermMonth_customerInfo']").val();
                        var cardUseTermYear = $("select[name='creditCardTermYear_customerInfo']").val();
                        // カード有効期限
                        var creditCardTerm = cardUseTermYear + cardUseTermMonth;

                        var year = '';
                        var month = '';
                        var day = '';
                        year = accountInfo.birth_day.substr(0, 4);
                        month = accountInfo.birth_day.substr(4, 2);
                        day = accountInfo.birth_day.substr(6, 2);

                        // 生年月日
                        var birthDate = year + month + day;

                        var tokenPan = '';
                        var token = '';
                        var tokenKey = '';

                        if (creditCardNo !== '') {
                            var torResponse = branchTorToken(creditCardNo, creditCardTerm, creditCardSecurityCode, birthDate);

                            var errorMessage = torResponseChecked(torResponse);
                            if (errorMessage === '') {
                                tokenPan = torResponse.authoriResponseInfo.creditCardNbr;

                                // sbpsのjs処理が読み込めているかチェックする
                                var communicationCheckResult = sbpsCommunicationCheck();

                                if (communicationCheckResult) {
                                    sbpsCompleteFlg = true;
                                    branchSbpsToken(creditCardNo, creditCardTerm, creditCardSecurityCode, function(sbpsResponse) {
                                        if (sbpsResponse.result === 'OK') {
                                            token = sbpsResponse.tokenResponse.token;
                                            tokenKey = sbpsResponse.tokenResponse.tokenKey;

                                            applyRegistInfo['token_pan'] = tokenPan;
                                            applyRegistInfo['pay_token'] = token;
                                            applyRegistInfo['pay_token_key'] = tokenKey;

                                            // 伝票登録API呼出
                                            $.ajax({
                                                timeout: 1000 * 30,
                                                async: false,
                                                cache: false,
                                                type: 'POST',
                                                dataType: 'json',
                                                url: '/aw/api/v1/mobileSalesOrders',
                                                contentType: 'application/json',
                                                data: JSON.stringify(applyRegistInfo),
                                                success: function (data) {
                                                    Complete.init(data.accept_number);
                                                    OLS.proceed('complete');
                                                },
                                                beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                                                    // 「申し込み内容を確定する」ボタンを活性化
                                                    $("#go-to-complete").removeClass("disabled");
                                                }
                                            });
                                        } else {
                                            sbpsCompleteFlg = false;

                                            // 処理エラーの場合アラート表示(連打防止のためエラーポップアップの表示を1秒遅らせる）
                                            setTimeout(function() {
                                                Utils.openModal(getMessage("popup_msg_sbps_system", "popup"), getMessage("popup_button_close", "popup"));
                                                // 「申し込み内容を確定する」ボタンを活性化
                                                $("#go-to-complete").removeClass("disabled");
                                            },1000);
                                            return false;
                                        }
                                    });
                                }
                            } else {
                                // アラート表示(連打防止のためエラーポップアップの表示を1秒遅らせる）
                                setTimeout(function() {
                                    Utils.openModal(errorMessage, getMessage("popup_button_close", "popup"));
                                    // 「申し込み内容を確定する」ボタンを活性化
                                    $("#go-to-complete").removeClass("disabled");
                                },1000);
                                return false;
                            }
                        }
                    }

                    // 伝票登録API呼出
                    if (!sbpsCompleteFlg) {
                        $.ajax({
                            timeout: 1000 * 30,
                            async: false,
                            cache: false,
                            type: 'POST',
                            dataType: 'json',
                            url: '/aw/api/v1/mobileSalesOrders',
                            contentType: 'application/json',
                            data: JSON.stringify(applyRegistInfo),
                            success: function (data) {
                                Complete.init(data.accept_number);
                                OLS.proceed('complete');
                            },
                            beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                                // 「申し込み内容を確定する」ボタンを活性化
                                $("#go-to-complete").removeClass("disabled");
                            }
                        });
                    }
                }
            }, 10);
        },

        identityGoToComplete: function () {
            // 二重送信を防ぐ実装
            $("#identity-go-to-complete").addClass("disabled");

            // 本人確認書類送付方法
            applyRegistInfo['id_document_send_style'] = '3';

            // 画像アップロード画像の取得
            identityNext();

            //本人確認書類リスト
            if (uploadFilesListId != null && uploadFilesListId != ""){

                // 契約書情報入力画面で登録した本人確認書類は、
                // 最後尾に区切り文字が無い場合、後続のループ処理で
                // カウンター（uploadFileNameListCount）がオーバーする。
                var jsonObjCode = uploadFilesListId.split(";");
                var jsonObjName = uploadFilesListName.split(";");
                var uploadFileNameListCount = 0;

                var array1 = [];
                var pageNo = 1;

                for(var upfilecnt = 0; upfilecnt < jsonObjCode.length; upfilecnt++) {

                    if (jsonObjCode.length <= uploadFileNameListCount) {
                        break;
                    }

                    // 内部変換した書類コードを、伝票登録ように再変換するためにsubstrする
                    var idDocumentCd = jsonObjCode[uploadFileNameListCount].substr(0, 3);

                    for(var uploadFileCount = 0; uploadFileCount< jsonObjCode.length; uploadFileCount++){

                        if(jsonObjCode[uploadFileNameListCount] != null
                            && jsonObjCode[uploadFileNameListCount] != ""
                            && idDocumentCd === jsonObjCode[uploadFileNameListCount].substr(0, 3)){

                            array1.push({
                                'id_document_cd': jsonObjCode[uploadFileNameListCount],
                                'upload_file_name' : jsonObjName[uploadFileNameListCount],
                                'page_no' : pageNo
                            });

                            uploadFileNameListCount++;
                            pageNo++;
                        }
                    }
                }
                applyRegistInfo['id_document_form_list'] = array1;
            }

            // 画像認証 入力コードチェック
            if (!isSb) {
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'POST',
                    dataType: 'json',
                    url: '/aw/api/v1/kaptchaCodeCheck',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        kaptchaCd: $('#kaptchaCode').val()
                    }),
                    success: function (data) {
                        executeEntrySlip();
                    },
                    beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                        // 認証画像再読み込み
                        $('#kaptchaImgChange').click();
                        // コード入力欄初期化
                        $('#kaptchaCode').val('');
                        // リンク・ボタン活性/非活性制御
                        imgSendSet();
                    }
                });
            } else {
                executeEntrySlip();
            }
        },
        // キャンペーン対象者本人確認書類選択プルダウンを設定する
        makePulldown: function () {
            // 契約者情報入力画面より国籍を取得
            var nationalityCd = '';
            if ($('#nationalityCdChecked').css('display') === 'flex') {
                nationalityCd = $("select[name='nationalityCd_customerInfo'] option:selected").val();
            }
            // 住所コード
            var address_code = $("#contractorAddressArea option:selected").val();
            // 契約者と異なる
            var contractorDiffirentFlg = false;
            if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg
                    && $('input[name=nonSbUserContractor_customerInfo]').is(":checked")) {
                contractorDiffirentFlg = true;
            }
            $.ajax({
                timeout: 1000 * 30,
                async: false,
                cache: false,
                type: 'POST',
                dataType: 'json',
                url: '/aw/api/v1/mobileSalesIdDocument/init',
                contentType: 'application/json',
                data: JSON.stringify({
                    nationalityCd: nationalityCd,
                    addressCode: address_code,
                    isSb: isSb,
                    contractorDiffirentFlg: contractorDiffirentFlg
                }),
                success: function (data) {
                    if (isAlreadyDrownIdDocumentListlength != data.IdntConfirmSendScrnDispResDto.IdDocumentGroupList.length
                         || isAdditionalIdDocumentListlength != data.IdntConfirmSendScrnDispResDto.AdditionalIdDocumentList.length
                         || isSbPrev != isSb) {
                        // 本人確認書類リストレロード判定用
                        isAlreadyDrownIdDocumentListlength = data.IdntConfirmSendScrnDispResDto.IdDocumentGroupList.length;
                        // 本人確認書類リスト以外レロード判定用
                        isAdditionalIdDocumentListlength = data.IdntConfirmSendScrnDispResDto.AdditionalIdDocumentList.length;
                        isSbPrev = isSb;

                        json = data;

                        // 本人確認書類欄の初期表示
                        $('#person').html("");
                        var userIdDocument = "";
                        if (isSb) {
                            // キャンペーン対象者本人確認書類欄の初期表示
                            userIdDocument = userIdDocument + "<h3 class='ttlBg'>キャンペーン対象者の本人確認書類</h3><div class='boxWh identityContentsBoxDesignHead'><p>キャンペーン対象者の新規登録または変更を行っているため、キャンペーン対象者の本人確認書類の提出が必要です。</p>";
                            userIdDocument = userIdDocument + "<a id='selfConfirmDetailItemHtml' href='https://online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html' target='_blank' class='link linkGra'>本人確認について更に詳しく見る<i class='icon icon-link iconGra'></i></a></div>";
                            userIdDocument = userIdDocument + "<div class='boxWh identityContentsBoxDesign listStripe tableLayout'><div class='item'><p class='inputName'>本人確認書類の種類を<br class='pc tb'>選択してください</p>";
                            userIdDocument = userIdDocument + "<div class='inputArea'><label class='select'><select name='' id='idDocumentGroupCd' onchange='documentChange();'></select></label><div id='selectGroupCdMsg'></div></div></div></div>";

                            $('#person').html(userIdDocument);
                        } else {
                            // 契約者本人確認書類欄の初期表示
                            userIdDocument = userIdDocument + "<h3 class='ttlBg'>契約者の本人確認書類</h3>";
                            userIdDocument = userIdDocument + "<div class='listStripe tableLayout'><div class='item'><p class='inputName'>本人確認書類の種類を<br class='pc tb'>選択してください</p>";
                            userIdDocument = userIdDocument + "<div class='inputArea'><label class='select'><select name='' id='idDocumentGroupCd' onchange='documentChange();'></select></label><div id='selectGroupCdMsg'></div>";
                            userIdDocument = userIdDocument + "<div class='linkArea'><a id='selfConfirmDetailItemHtml' href='https://online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html' target='_blank' class='link linkGra'>本人確認について更に詳しく見る<i class='icon icon-link iconGra'></i></a></div></div></div></div>";

                            $('#person').html(userIdDocument);

                            // 契約者情報入力画面より国籍を取得
                            var nationalityCd = '';
                            if ($('#nationalityCdChecked').css('display') === 'flex') {
                                nationalityCd = $("select[name='nationalityCd_customerInfo'] option:selected").val();
                            }
                            if (nationalityCd == "01") {
                                // 在留カード（一般永住者）を設定する
                                $("#documentDiv #idDocumentGroupCd").val("X");
                            } else if (nationalityCd == "02") {
                                // 在留カード + 外国パスポートを設定する
                                $("#documentDiv #idDocumentGroupCd").val("s");
                            } else {
                                // 運転免許証を設定する
                                $("#documentDiv #idDocumentGroupCd").val("1");
                            }
                        }

                        // 本人確認書類の種類選択の初期化
                        $('#idDocumentGroupCd').html("");

                        var str = '';
                        var mapList = data.IdntConfirmSendScrnDispResDto.IdDocumentGroupList;
                        for (var i in mapList) {
                            str = str + "<option value='" + mapList[i]["idDocumentGroupCd"] + "'>" + mapList[i]["idDocumentGroupName"] + "</option>";
                        }
                        $("#idDocumentGroupCd").append(str);

                        documentChange(data);
                    }
                }
            });
        },

        proceed: function (p) {

            // loadingを表示する
            location.hash = 'loading';
            showLoading();

            // パンくずを残して
            $('body > div#' + p + ', body > div#container > main#' + p).addClass('history');
            // 上まで飛ぶ  
            goToTop(1); // 0 効かないので 1 にした
            location.hash = p;

            // WTRのタグ（S_NO）埋め込み
            Utils.setWtrSno();

            // GAサイト分析
            var gaString = getEnviromentInfo(gaList);
            if (gaString) {
                setTimeout(gaString, 50);
            }
        },

        // 決済方法の切り替え
        changePayMethod : function (isCreditCard) {
            // クレジットカード
            if (isCreditCard) {
                $("#payStyle02").prop("checked", true);
                $("#payStyleCreditCard").addClass('checked');
                $("#payStyle01").prop("checked", false);
                $("#payStyleCOD").removeClass('checked');
                // セキュリティコード？
                if ($("#creditCardSecurityCodePopBtn")) {
                    var srcUrl = getEnviromentInfo(securityCodeList);
                    $("#creditCardSecurityCodePopBtn").load(srcUrl);
                }
                // クレジットカード情報を表示
                $("#creditCardDetails").show();
            } else {
                $("#payStyle02").prop("checked", false);
                $("#payStyleCreditCard").removeClass('checked');
                $("#payStyle01").prop("checked", true);
                $("#payStyleCOD").addClass('checked');
                // クレジットカード情報を非表示
                $("#creditCardDetails").hide();
            }
            // バリデーションチェック
            $('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
                validateItem(Delivery, $(this), true);
            });
            // ボタン制御
            $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
        },

        pageInit: function () {
            // 画面項目の初期化
            // ------------------
            // 機種選択画面
            // ------------------
            initDoneFlag = false;
            $('.sba-identity[title="s_no"]').remove();

            // ------------------
            // お客さま情報入力 非SB
            // ------------------
            // 氏名
            $('#nonSbCustomerInfoEntry #contractorNameSei').val('');
            $('#nonSbCustomerInfoEntry #contractorNameMei').val('');
            $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val('');
            $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val('');
            // 生年月日
            $("#nonSbCustomerInfoEntry #birthDateYear option[value='']").prop("selected", true);
            $("#nonSbCustomerInfoEntry #birthDateMonth option[value='']").prop("selected", true);
            $("#nonSbCustomerInfoEntry #birthDateDay option[value='']").prop("selected", true);
            // 性別
            $("#nonSbCustomerInfoEntry [name='sexCd_customerInfo']:checked").prop("checked", false).parent().removeClass("checked");
            // 国籍
            $("#nonSbCustomerInfoEntry #nationalityCd option[value='']").prop("selected", true);
            // 住所
            $('#nonSbCustomerInfoEntry #contractorZipCd').val('');
            $('#nonSbCustomerInfoEntry .contractorAddressArea').hide();
            $('#contractorAddressArea').html('');
            $('#addSearchFromZipSelect').hide();
            $('#nonSbCustomerInfoEntry #contractorAddressGaiku').val('');
            $('#nonSbCustomerInfoEntry #contractorAddressIncidental').val('');
            // 連絡先電話番号
            $('#nonSbCustomerInfoEntry #contractorTelNo').val('');
            // 職業
            $("#nonSbCustomerInfoEntry #nonSbJobCd option[value='']").prop("selected", true);
            // 職業名
            $("#nonSbCustomerInfoEntry #jobSupplement").val('');
            $("#nonSbCustomerInfoEntry .otherjob").hide();
            // 勤務先名
            $("#nonSbCustomerInfoEntry #nonSbOfficeName").val('');
            // 勤務先名フリガナ
            $("#nonSbCustomerInfoEntry #nonSbOfficeNameKana").val('');
            // 勤務先電話番号
            $("#nonSbCustomerInfoEntry #nonSbOfficeTelNo").val('');
            // 勤務先各情報非表示
            $("#nonSbCustomerInfoEntry .nonSbContractorOffice").hide();
            // Eメールアドレス
            $('#nonSbCustomerInfoEntry #contactToEmailAddress').val('');
            $('#nonSbCustomerInfoEntry #contactToEmailAddressForCheck').val('');
            // 契約者と異なる
            $("#nonSbCustomerInfoEntry #nonSbUserContractorDiffirent").prop("checked", false).parent().removeClass("checked");
            // キャンペーン対象者の氏名
            $('#nonSbCustomerInfoEntry #nonSbUserNameSei').val('');
            $('#nonSbCustomerInfoEntry #nonSbUserNameMei').val('');
            $('#nonSbCustomerInfoEntry #nonSbUserNameSeiKana').val('');
            $('#nonSbCustomerInfoEntry #nonSbUserNameMeiKana').val('');
            // キャンペーン対象者の生年月日
            $("#nonSbCustomerInfoEntry #nonSbUserBirthDateYear option[value='']").prop("selected", true);
            $("#nonSbCustomerInfoEntry #nonSbUserBirthDateMonth option[value='']").prop("selected", true);
            $("#nonSbCustomerInfoEntry #nonSbUserBirthDateDay option[value='']").prop("selected", true);
            // キャンペーン対象者の性別
            $("#nonSbCustomerInfoEntry [name='nonSbUserSexCd_customerInfo']:checked").prop("checked", false).parent().removeClass("checked");
            // 暗証番号
            $('#nonSbCustomerInfoEntry #hlrPassword').val('');
            // 支払い情報の入力に進む
            $('#btn-to-delivery-pay').addClass('disabled');

            // ------------------
            // お客さま情報入力 SB
            // ------------------
            // 連絡先電話番号
            $('#sbCustomerInfoEntry #contactTelNo').val('');
            $('#sbCustomerInfoEntry #sb-customerinfo-tel-num-input').hide();
            // 職業
            $("#sbCustomerInfoEntry #sbJobCd option[value='']").prop("selected", true);
            // 職業名
            $("#sbCustomerInfoEntry #sbJobSupplement").val('');
            $("#sbCustomerInfoEntry .sbOtherjob").hide();
            // 勤務先名
            $("#sbCustomerInfoEntry #sbOfficeName").val('');
            // 勤務先名フリガナ
            $("#sbCustomerInfoEntry #sbOfficeNameKana").val('');
            // 勤務先電話番号
            $("#sbCustomerInfoEntry #sbOfficeTelNo").val('');
            $("#sbCustomerInfoEntry .sbContractorOffice").hide();
            // キャンペーン対象者の氏名
            $('#sbCustomerInfoEntry #sbUserNameSei').val('');
            $('#sbCustomerInfoEntry #sbUserNameMei').val('');
            $('#sbCustomerInfoEntry #sbUserNameSeiKana').val('');
            $('#sbCustomerInfoEntry #sbUserNameMeiKana').val('');
            // キャンペーン対象者の生年月日
            $("#sbCustomerInfoEntry #sbUserBirthDateYear option[value='']").prop("selected", true);
            $("#sbCustomerInfoEntry #sbUserBirthDateMonth option[value='']").prop("selected", true);
            $("#sbCustomerInfoEntry #sbUserBirthDateDay option[value='']").prop("selected", true);
            // キャンペーン対象者の性別
            $("#sbCustomerInfoEntry [name='sbUserSexCd_customerInfo']:checked").prop("checked", false).parent().removeClass("checked");
            // Eメールアドレス
            $('#sbCustomerInfoEntry #contactToEmailAddress').val('');
            $('#sbCustomerInfoEntry #contactToEmailAddressForCheck').val('');
            // 暗証番号
            $('#sbCustomerInfoEntry #sbhlrPassword').val('');

            // ------------------
            // 配送情報入力
            // ------------------
            // 配送先
            $("#delivery [name='deliveryToAddressKbn_customerInfo']:checked").prop("checked", false);
            $('#delivery .checked').removeClass("checked");
            // 別の住所
            $('#delivery #deliveryToAddressInputArea').hide();
            $('#delivery #sendToZipCd').val('');
            $('#delivery .sendToAddressArea').hide();
            $('#delivery #sendToAddSearchFromZipSelect').hide();
            $('#delivery #sendToAddressGaiku').val('');
            $('#delivery #sendToAddressIncidental').val('');

            // ------------------
            // 支払い情報入力
            // ------------------
            // 支払い情報
            // カード番号
            $('#pay #billCreditCardNo').val('');
            // セキュリティコード
            $('#pay #billSecurityCode').val('');
            // カード名義フリガナ
            $('#pay #billCreditCardOwnerSeiKana').val('');
            $('#pay #billCreditCardOwnerMeiKana').val('');
            // カード会社名
            $("#pay #billCreditCardCompanyId option[value='']").prop("selected", true);
            // カード有効期限
            $("#pay #billCreditCardTermMonth option[value='']").prop("selected", true);
            $("#pay #billCreditCardTermYear option[value='']").prop("selected", true);
            // 規約同意に進む
            $('#btn-pay-to-agreement').addClass('disabled');

            // ------------------
            // 規約同意
            // ------------------
            $("#agreement #allAgree").prop("checked", false);
            $("#agreement .checked").removeClass("checked");
            // 申し込み内容の確認に進む
            $('#go-to-confirm').addClass('disabled');

            // ------------------
            // 確認画面
            // ------------------
            $('#confirm .checked').removeClass('checked');

            // ------------------
            // 契約者情報
            // ------------------
            accountInfo = undefined;
            isTerminal = undefined;
        },

        displayShopLogo: function (logoFileName) {

            if (!isEmpty(logoFileName)) {
                var shopLogo = getEnviromentInfo(shopLogoList);
                shopLogo = shopLogo + logoFileName;
                // 代理店ロゴを表示させる
                $('#headerImgId').html(`<img class="header_style" src="${shopLogo}"
                onerror="this.style.display='none';">`);
            }
        }
    };

    // パラメータの解析
    var r = '[?&]([^=]+)=([^#&]*)';
    var p = location.search.match(new RegExp(r, 'g'));
    var h = {};
    $.each(p || [], function (i, v) {
        var _p = v.match(new RegExp(r));
        h[_p[1]] = _p[2];
    });

    // UA判定、classを設定する
    UA = getUA();
    if (UA.isIE) $('html').addClass('thisIE');
    if (UA.isChrome) $('html').addClass('thisChrome');
    if (UA.isWindows) $('html').addClass('thisWindows');

    // UAチェックファンクション呼び出し
    userAgentChk();

    // 認証URL
    APPROVEURL_URL = getEnviromentInfo(approveurlList);

    // olsInitString情報
    var olsInitString = getEnviromentInfo(olsInitStringList);
    if (olsInitString) {
        setTimeout(olsInitString, 50);
    }
});

$(document).ready(function () {
    // チェックボックスのCSS設定
    $("input[type=checkbox]").on("click", function () {
        $(this).parent().toggleClass("checked");
    });

   // 職業セレクトボックスのチェンジイベント。
    $(document).on('change', '#nonSbJobCd, #sbJobCd', function(event) {
        viewContractorOffice($(this));
    });

    var posArray = new Array();
    $(window).on('scroll load touchmove resize', function() {

        for (var i = 0; i < $('.flowList').length; i++) {

            var href = $('.flowList').eq(i).find('a').attr('href');
            var target = $(href == '#' || href == '' || !href ? 'html' : href);
            posArray[i] = target.offset().top;

            if(i == $('.flowList').length-1) {
                scrollCheck(posArray);
            }
        }
        
        // 機種代金シミュレータ表示範囲設定
        priceSimulatorArea();
        setTimeout(function () {
            $(".floatInfo").css("bottom","0px");
        },200 );
    });
    
    $(document).on('click', '#tradeInRecoveryKitGuidance .j_toggleBtn', function() {
        // 機種の回収・下取り欄
        if ($('#tradeInRecoveryKitGuidance .j_toggleBtn').hasClass('active')){
            // アコーディオンを閉じる
            $('#tradeInRecoveryKitGuidance .j_toggleBtn').removeClass('active');
            $('#tradeInRecoveryKitGuidance .j_toggleDetail').slideUp(200).removeClass('active');
        } else {
            // アコーディオンを開く
            $('#tradeInRecoveryKitGuidance .j_toggleBtn').addClass('active');
            $('#tradeInRecoveryKitGuidance .j_toggleDetail').slideDown(200).addClass('active');
        }
        // ボタンの文言の切り替え
        if ($('#tradeInRecoveryKitGuidanceBtn').text() === '詳しくみる') {
            $('#tradeInRecoveryKitGuidanceBtn').text('　閉じる　');
        } else {
            $('#tradeInRecoveryKitGuidanceBtn').text('詳しくみる');
        }
    });

    // 規約同意のscroll
    if (UA.isSp || UA.isTab) {
        $(".scrollArea").css("overflow-y", "auto");
    } else {
        $(".scrollArea").css("overflow-y", "hidden");
    }
});

$(function () {
    //ReserveLogin
    $('#reserveLogin input').focusout(function () {
        validateItem(ReserveLogin, $(this));
    }).bind('keyup change', function () {
        validateItem(ReserveLogin, $(this));
        $('#reserveLogin div.btnArea a.btn.button-next').toggleClass('disabled', preventProceed(ReserveLogin));
    })

    // Contractor ReserveLogin
    $('#contractorReserveNo').focusout(function () {
        validateItem(ContractorReserveLogin, $(this));
    }).bind('keyup change', function () {
        validateItem(ContractorReserveLogin, $(this));
        $('#go-to-mySoftbank-login').toggleClass('disabled', preventProceed(ContractorReserveLogin));
    })

    // NonSbCustomerInfoEntry
    $('#nonSbCustomerInfoEntry input, #nonSbCustomerInfoEntry select').blur(function () {
        validateItem(NonSbCustomerInfoEntry, $(this));
    }).bind('keyup change', function () {
        // 「契約者情報と同じにする」をチェックした場合
        if ($("input[name='nonSbUserContractor_customerInfo']").is(':checked')) {
            $('#nonSbCustomerInfoEntry .userInfoArea').show();
        } else {
            $('#nonSbCustomerInfoEntry .userInfoArea').hide();
        }
        validateItem(NonSbCustomerInfoEntry, $(this));
        NonSbCustomerInfoEntry.checkUserContractorDiffirent_customerInfo();
        $('#btn-to-delivery-pay').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
    });

    $('#nonSbCustomerInfoEntry div.contractorAddressArea input[type=text]').focus(function () {
        validateItem(NonSbCustomerInfoEntry, $('#nonSbCustomerInfoEntry #contractorAddressArea'));
    });

    //Zipcode handler
    $('#nonSbCustomerInfoEntry #contractorZipCd').change(Utils.zipcodeKeydownHandler);
    $('#nonSbCustomerInfoEntry #contractorZipCd').formatter({
        'pattern' : '{{999}}-{{9999}}'
    });

  $('#sbCustomerInfoEntry input, #sbCustomerInfoEntry select').focusout(function () {
      validateItem(SbCustomerInfoEntry, $(this));
  }).bind("keyup change", function () {
      validateItem(SbCustomerInfoEntry, $(this));
      $('#sbCustomerInfoEntry .btnArea .btn').toggleClass('disabled', preventProceed(SbCustomerInfoEntry));
  });
});

$(function () {
    $('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').focusout(function (e) {
        validateItem(Delivery, $(this));
    }).bind('keyup change', function () {
        validateItem(Delivery, $(this));
        $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
    });

    $('#delivery div.sendToAddressArea input[type=text]').focus(function () {
        validateItem(Delivery, $(this));
    })

    //Zipcode handler
    $('#delivery #sendToZipCd').change(Utils.zipcodeKeydownHandler);
    $('#delivery #sendToZipCd').formatter({
        'pattern' : '{{999}}-{{9999}}'
    });
});

$(function () {
    //Pay
    $('#pay input').blur(function () {
        validateItem(Pay, $(this));
    }).bind('keyup change', function () {
        validateItem(Pay, $(this));
        $('#btn-pay-to-agreement').toggleClass('disabled', preventProceed(Pay));
    });

    $('#pay select').blur(function () {
        validateItem(Pay, $(this));
    }).bind('keyup change', function () {
        validateItem(Pay, $(this));
        $('#btn-pay-to-agreement').toggleClass('disabled', preventProceed(Pay));
    });

});

// 性別を選択する時のアニメーション
$(function () {
    $('.radioBox').click(function (e) {
        if($(this).prop('id') != 'payStyleCreditCard' && !$(this).hasClass("disabled")){
            $(this).siblings('.radioBox').removeClass('checked');
            $(this).addClass('checked');
        }
    });

    // 「別に住所の配送を希望する」OFF⇒ON
    $(document).on('click', 'input:checked#otherAddress', function(){
        var clickTimes = parseInt($('#otherAddress').attr('data-clickTimes'), 10);

        $('#deliveryToAddressInputArea').show();
        // バリデーションチェック
        //$('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
        $('#deliveryToAddressInputArea select, #deliveryToAddressInputArea input, #otherAddress').each(function(){
            validateItem(Delivery, $(this), true);
        });
        $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));

        clickTimes = clickTimes + 1;
        $('#otherAddress').attr('data-clickTimes', clickTimes.toString(10));

        // 初回クリック以外バリデーションチェックを行う
        if (clickTimes > 1) {
            //$('#delivery select, #delivery div.sendToAddressArea:not(:last-child) input[type=text], #delivery input[type=tel]').change();
            $('#deliveryToAddressInputArea select, #deliveryToAddressInputArea input, #otherAddress').change();
        }
    });
    // 「別に住所の配送を希望する」ON⇒OFF
    $(document).on('click', 'input:not(:checked)#otherAddress', function(){
        $("#otherAddress").prop("checked", false);
        $("#otherAddress").parent().parent().removeClass("checked");
        $('#deliveryToAddressInputArea').hide();
        // バリデーションチェック
        //$('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
        $('#deliveryToAddressInputArea select, #deliveryToAddressInputArea input, #otherAddress').each(function(){
            validateItem(Delivery, $(this), true);
        });
        // ボタン制御
        $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
    });

    $('label.btnSelect input[type=checkbox]').click(function (e) {
        $(this).closest('label').toggleClass('checked');
    });
    $('#agreement form.formReset .btnArea label.btnSelect input[type=checkbox]#allAgree').click(function (e) {
        if ($(this).is(':checked')) {
            $('#agreement #link .btnArea > a').removeClass('disabled');
        } else {
            $('#agreement #link .btnArea > a').addClass('disabled');
        }
    });
});

//TOPに戻る矢印のアニメーション
$(function () {
    var topBtn = $('#pagetop');
    topBtn.hide().click(goToTop);
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
});

function goToTop(duration) {
    $('body,html').animate({
        scrollTop: 0
    }, duration || 0);
    return false;
};

// 入力画面各情報のvalid状態初期化
function resetVaildValue (keyId) {
    // 未入力かつエラー状態無しの場合
    if ($('#' + keyId + '.error').length == 0) {
        // 未入力かつエラー状態無しの場合
        if (isSb) {
            SbCustomerInfoEntry.validated[keyId].valid = '';
        } else {
            NonSbCustomerInfoEntry.validated[keyId].valid = '';
        }
    } else {
        // エラー状態有りの場合
        if (isSb) {
            SbCustomerInfoEntry.validated[keyId].valid = false;
        } else {
            NonSbCustomerInfoEntry.validated[keyId].valid = false;
        }
    }
}

// 職業の表示制御。
function viewContactJob() {
    var tokusuruSupportJudgeKbn = '';
    var tokusuruSupportVal = '';
    if ($('input[name="privilegeUseSelect"]:checked').val()) {
        tokusuruSupportJudgeKbn = $('input[name="privilegeUseSelect"]:checked').val().split(',')[0];
        tokusuruSupportVal = $('input[name="privilegeUseSelect"]:checked').val().split(',')[1];
    }
    // 機種の回収・下取り欄の特典利用欄を選択している場合
    if ($('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
        && ((tokusuruSupportJudgeKbn === TOKUSURU_SUPPORT_JUDGE_KBN.tokusuruSupport
            && (tokusuruSupportVal === TOKUSURU_SUPPORT_USE_CODE_LIST.TokusuruSupport_UseOfUpgradeInOneYearCampaign
                    || tokusuruSupportVal === TOKUSURU_SUPPORT_USE_CODE_LIST.TokusuruSupport_Use))
            || tokusuruSupportJudgeKbn === TOKUSURU_SUPPORT_JUDGE_KBN.tokusuruSupportPlus
            || tokusuruSupportJudgeKbn === TOKUSURU_SUPPORT_JUDGE_KBN.newTokusuruSupport
            || isTradeInProgram(tokusuruSupportJudgeKbn))) {
        // トクするサポート選択時（トクするサポートの解約選択時（利用料の還元）、解約時は表示しない）
        // トクするサポート＋選択時
        // 新トクするサポート選択時
        // 下取りプログラム選択時
        return true;
    }
    return false;
}

// 勤務先情報入力欄の表示制御。
function viewContractorOffice(item) {
    var val = item.val();
    var id = item.attr('id');
    var contractorOtherJob = '';

    // 勤務先項目
    // 職業名(補足)
    if (isSb) {
        contractorOtherJob = $('div.sbOtherjob');
    } else {
        contractorOtherJob = $('div.otherjob');
    }

    if (isSb) {
        var contractorOffice = $('div.sbContractorOffice');
        var contractorOfficeInput = $('div.sbContractorOffice input');
        var contractorOfficeSelect = $('div.sbContractorOffice select');
    } else {
        var contractorOffice = $('div.nonSbContractorOffice');
        var contractorOfficeInput = $('div.nonSbContractorOffice input');
        var contractorOfficeSelect = $('div.nonSbContractorOffice select');
    }
    if (val !== '') {
        // 文字色彩の変更
        $('#' + id + '').removeClass("placeholder");
        // 選択してください以外を選択した場合、勤務先情報入力欄を表示にする。
        contractorOffice.show();
        // 職業は「その他」の場合、職業名入力欄表示
        if (val === JOB_CD_LIST.other) {
            contractorOtherJob.show();
            // 勤務先情報入力欄のストライプの設定
            if (isSb) {
                setListStripe(contractorOffice, BG_COLOR.white, BG_COLOR.gray);
            } else {
                setListStripe(contractorOffice, BG_COLOR.gray, BG_COLOR.white);
            }
        } else {
            contractorOtherJob.hide();
            // 勤務先情報入力欄のストライプの設定
            setListStripe(contractorOffice, BG_COLOR.gray, BG_COLOR.white);
        }

        // 勤務先名、勤務先名フリガナ、勤務先電話番号は必須項目に設定
        if (val === JOB_CD_LIST.employee
                || val === JOB_CD_LIST.publicOfficials
                || val === JOB_CD_LIST.selfEmployed
                || val === JOB_CD_LIST.employeeSelfEmployee
                || val === JOB_CD_LIST.twoIncomes
                || val === JOB_CD_LIST.other) {
            contractorOffice.find('.requiredText').text('※必須');
            contractorOfficeInput.attr('required', '');
            contractorOfficeSelect.attr('required', '');
        } else {
           // 職業が上記以外の場合は
           // 勤務先名、勤務先名フリガナ、勤務先電話番号は必須項目を解除 
            contractorOffice.find('.requiredText').text('');
            contractorOfficeInput.removeAttr('required');
            contractorOfficeSelect.removeAttr('required');
        }
    } else {
        // 
        $('#' + id + '').removeClass("placeholder");
        // 上記以外（選択してください）を選択した場合、勤務先情報入力欄を非表示にする。
        contractorOffice.hide();
        contractorOtherJob.hide();
    }
}

// 入力画面バリデーションチェック 
function viewContractorInfoCheck() {
    // 契約者情報チェック
    if (!isSb) {
        // 契約者姓と名の合計文字数を45以下にする
        var lastNameLength = $('#nonSbCustomerInfoEntry #contractorNameSei').val().length;
        var firstNameLength = $('#nonSbCustomerInfoEntry #contractorNameMei').val().length;
        if (lastNameLength + firstNameLength > 45) {
            Utils.openModal(getMessage("popup_lastname_firstname_total_size", "popup"), getMessage("popup_button_close", "popup"));
            return false;
        }

        // 契約者姓(カナ)と名(カナ)の合計文字数を29以下にする
        var lastNameKanaLength = $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val().length;
        var firstNameKanaLength = $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val().length;
        if (lastNameKanaLength + firstNameKanaLength > 29) {
            Utils.openModal(getMessage("popup_lastnamekana_firstnamekana_total_size", "popup"), getMessage("popup_button_close", "popup"));
            return false;
        }

        // バリデーションチェック 住所入力欄の郵便番号検索後のプルダウン未選択時
        if ($('#contractorAddressArea option:selected').val() == '0') {
            Utils.openModal(getMessage("popup_address_pulldown_no_select", "popup"), getMessage("popup_button_close", "popup"));
            return;
        }

        //  都道府県からの住所の合計文字数を60以下にする
        var address1Length = addressInfo[$('#contractorAddressArea option:selected').val()].length;
        var address2Length = $('#nonSbCustomerInfoEntry #contractorAddressGaiku').val().length;
        var address3Length = $('#nonSbCustomerInfoEntry #contractorAddressIncidental').val().length;
        if (address1Length + address2Length + address3Length > 60) {
            Utils.openModal(getMessage("popup_address_total_size", "popup"), getMessage("popup_button_close", "popup"));
            return false;
        }

        // 生年月日の有効チェック
        var checkValidDateMsg = NonSbCustomerInfoEntry.checkValidDate();
        if (checkValidDateMsg != '') {
            Utils.openModal(checkValidDateMsg, getMessage("popup_button_close", "popup"));
            return false;
        }

        // 契約者年齢20以下のチェック
        var checkValidBirthDateMsg = NonSbCustomerInfoEntry.checkValidBirthDate();
        if (checkValidBirthDateMsg != '') {
            Utils.openModal(checkValidBirthDateMsg, getMessage("popup_button_close", "popup"));
            return false;
        }
    }

    // 非必須入力職業場合 入力確認
    // 権利行使するの場合
    if ((!isSb && pageController.goodsSelectedInfo.installment)
            || viewContactJob()) {
        var OfficeName;
        var OfficeNameKana;
        var OfficeTelNo;
        if(isSb){
            // 勤務先名
            OfficeName = $('#sbOfficeName');
            // 勤務先名フリガナ
            OfficeNameKana = $('#sbOfficeNameKana');
            // 勤務先電話番号
            OfficeTelNo = $('#sbOfficeTelNo');
        } else {
            // 勤務先名
            OfficeName = $('#nonSbOfficeName');
            // 勤務先名フリガナ
            OfficeNameKana = $('#nonSbOfficeNameKana');
            // 勤務先電話番号
            OfficeTelNo = $('#nonSbOfficeTelNo');
        }
        var contractorOfficeMessage = '';
        if((checkEmpty(OfficeName) || checkEmpty(OfficeNameKana) || checkEmpty(OfficeTelNo)) 
                && !(checkEmpty(OfficeName) && checkEmpty(OfficeNameKana) && checkEmpty(OfficeTelNo))){
            if(checkEmpty(OfficeName)){
                contractorOfficeMessage += '「勤務先名」を入力（又は選択）していただく必要があります。'
                if(checkEmpty(OfficeNameKana)){
                    contractorOfficeMessage += '<br>「勤務先名フリガナ」を入力（又は選択）していただく必要があります。'
                }else if(checkEmpty(OfficeTelNo)){
                    contractorOfficeMessage += '<br>「勤務先電話番号」を入力（又は選択）していただく必要があります。'
                }
            }else if(checkEmpty(OfficeNameKana)){
                contractorOfficeMessage += '「勤務先名フリガナ」を入力（又は選択）していただく必要があります。'
                if(checkEmpty(OfficeTelNo)){
                    contractorOfficeMessage += '<br>「勤務先電話番号」を入力（又は選択）していただく必要があります。'
                }
            }else{
                contractorOfficeMessage += '「勤務先電話番号」を入力（又は選択）していただく必要があります。'
            }
            Utils.openModal(contractorOfficeMessage, getMessage("popup_button_close", "popup"));
            return false;
        }
    }
    
    // キャンペーン対象者情報チェック
    // SBまたは（非SB、契約者と異なる選択した）時
    if (pageController.goodsSelectedInfo.studentDiscountSelectedFlg
            &&(isSb || (!isSb && $("input[name='nonSbUserContractor_customerInfo']").is(':checked')))) {
        var userLastNameLength = 0;
        var userFirstNameLength = 0;
        var userLastNameKanaLength = 0;
        var userFirstNameKanaLength = 0;
        if (isSb) {
            // 姓と名
            userLastNameLength = $('#sbCustomerInfoEntry #sbUserNameSei').val().length;
            userFirstNameLength = $('#sbCustomerInfoEntry #sbUserNameMei').val().length;
            // 姓(カナ)と名(カナ)
            userLastNameKanaLength = $('#sbCustomerInfoEntry #sbUserNameSeiKana').val().length;
            userFirstNameKanaLength = $('#sbCustomerInfoEntry #sbUserNameMeiKana').val().length;
            // 生年月日
            var userbirthdayY = $('#sbCustomerInfoEntry #sbUserBirthDateYear').val();
            var userbirthdayM = $('#sbCustomerInfoEntry #sbUserBirthDateMonth').val();
            var userbirthdayD = $('#sbCustomerInfoEntry #sbUserBirthDateDay').val();
        } else {
            // 姓と名
            userLastNameLength = $('#nonSbCustomerInfoEntry #nonSbUserNameSei').val().length;
            userFirstNameLength = $('#nonSbCustomerInfoEntry #nonSbUserNameMei').val().length;
            // 姓(カナ)と名(カナ)
            userLastNameKanaLength = $('#nonSbCustomerInfoEntry #nonSbUserNameSeiKana').val().length;
            userFirstNameKanaLength = $('#nonSbCustomerInfoEntry #nonSbUserNameMeiKana').val().length;
            // 生年月日
            var userbirthdayY = $('#nonSbCustomerInfoEntry #nonSbUserBirthDateYear').val();
            var userbirthdayM = $('#nonSbCustomerInfoEntry #nonSbUserBirthDateMonth').val();
            var userbirthdayD = $('#nonSbCustomerInfoEntry #nonSbUserBirthDateDay').val();
        }
        // キャンペーン対象者 姓と名の合計文字数を45以下にする
        if (userLastNameLength + userFirstNameLength > 45) {
            Utils.openModal(getMessage("popup_user_lastname_firstname_total_size", "popup"), getMessage("popup_button_close", "popup"));
            return false;
        }
        // キャンペーン対象者姓(カナ)と名(カナ)の合計文字数を45以下にする
        if (userLastNameKanaLength + userFirstNameKanaLength > 45) {
            Utils.openModal(getMessage("popup_user_lastnamekana_firstnamekana_total_size", "popup"), getMessage("popup_button_close", "popup"));
            return false;
        }

        // 生年月日の有効チェック
        if (!checkDate(userbirthdayY + "/" + userbirthdayM + "/" + fillZero(userbirthdayD, 2))) {
            Utils.openModal(getMessage("popup_user_birthday", "popup"), getMessage("popup_button_close", "popup"));
            return false;
        }

        // キャンペーン対象者年齢0歳未満のチェック
        var date = new Date(openDate);
        date.setFullYear(userbirthdayY);
        date.setMonth(userbirthdayM - 1);
        date.setDate(userbirthdayD);
        var maximumDate = new Date(openDate);
        maximumDate.setFullYear(maximumDate.getFullYear());
        if (date >= maximumDate) {
            Utils.openModal(getMessage("popup_user_birthday", "popup"), getMessage("popup_button_close", "popup"));
            return false;
        }
    }
    return true;
}

var agreeCtl = {
        agreeLoad: function () {
            $(".agreeAllBRDesign").remove();
            $('.agree-info .stripeItem').each(function() {
                if ($(this).css('display') !== 'none') {
                    $(this).css('background-color', '#ececec');
                    $(this).after('<br class="agreeAllBRDesign">');
                }
            });
        }
};

var clickHandlers = {
    // 非SB顧客入力画面で「住所を検索する」を押した時のイベント
    addSearchFromZip: function () {
        NonSbCustomerInfoEntry.displayContractorAddressArea($('#contractorZipCd'));
    },

    // 配送画面で「住所を検索する」を押した時のイベント
    sendToAddSearchFromZip: function () {
        Delivery.displayContractorAddressArea($('#delivery #sendToZipCd'));
    },

    contractBtn_agreement: function (e) {
        $(e.target).parent().find('a').toggleClass('active');
        $(e.target).parent().find('a').parent().siblings('.j_toggleDetail').toggle();
    },

    pageOpenCloseToggle: function (e) {
        $(e.target).parent().parent().parent().find('.pageOpen').toggle();
        $(e.target).parent().parent().parent().find('.pageClose').toggle();
    },

    closeModal: function () {
        $('#j_modalBoxClose').click();
    },
    // 本人確認書類認証番号別の画像を表示する
    kaptchaImgChange: function () {
        $('#kaptchaImg').attr('src', '/aw/Kaptcha.jpg?v=' + new Date().getTime());
        $('#kaptchaCode').val('');
    }
};

//受取方法選択状態により、機種の選択画面表示制御
function modelSelectReceiptCtrl() {
    var procedureStr = "";
    // O2O店舗受取固定
    if ($("input[name=receiptChgCtrl]:checked").val() == RECEIPT_STYLE_CTRL_SHOP) {
        // o2o 店舗受取
        procedureStr += '<li><i class="icon addicon icon-store_lt2 pr"></i><p><span>店舗受け取り</span></p></li>';
    } else {
        // 直送 w2t自宅受取固定
        procedureStr += '<li><i class="icon icon-home_lt pr"></i><p><span>自宅受け取り</span></p></li>';
    }
    $("#main .selectedServiceBox ul").html(procedureStr);
}

/**
 * 選択可能な受取方法が代理店として許可の受取方法の場合
 */
function isAgncyIdOk(homeData, shopData) {
    var isOk = true;
    var homeAgncyId = new RegExp('^' + homeData.join('$|^') + '$');
    var shopAgncyId = new RegExp('^' + shopData.join('$|^') + '$');
    var receiptVal = $("[name='receiptChgCtrl']:checked").val();

    // 直送固定
    if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.HOME || ITEM_TYPE_ONLY_HOME.indexOf(arr.itemType) > -1 || params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID) {
        // 代理店ID 直送非許可
        if (!(homeAgncyId.test(params.agncyId))) {
            location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_url", "errPage")));
            throw new error();
        }
    // O2O固定
    } else if (params.receiptStyleCtrl == RECEIPT_STYLE_CTRL.SHOP) {
        // 代理店ID o2o非許可
        if (!(shopAgncyId.test(params.agncyId))) {
            location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_url", "errPage")));
            throw new error();
        }
    } else {

        // 直送選択
        if (receiptVal == RECEIPT_STYLE_CTRL.HOME) {
            // 代理店ID 直送非許可
            if (!(homeAgncyId.test(params.agncyId))) {
                //代理店ID o2o非許可
                if (!(shopAgncyId.test(params.agncyId))) {
                    location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_url", "errPage")));
                    throw new error();
                } else {
                    //代理店ID o2o許可
                    alert(getMessage("message_alert_agncy"));
                    isOk = false;
                }
            }
        } else if (receiptVal == RECEIPT_STYLE_CTRL.SHOP) {
            //代理店ID o2o非許可
            if (!(shopAgncyId.test(params.agncyId))) {
                //代理店ID 直送非許可
                if (!(homeAgncyId.test(params.agncyId))) {
                    location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_url", "errPage")));
                    throw new error();
                } else {
                    //代理店ID 直送許可
                    alert(getMessage("message_alert_agncy"));
                    isOk = false;
                }
            }
        }
    }
    return isOk;
};

/**
 * W2Tから予約申込された機種は、管理画面「商品情報（移動機）」の受取情報の受取方法：o2oにチェック有りの機種であること。
 * @param modelData
 * @param goodsStock
*/
function denwatenTargetFlgChk(modelData, goodsStock) {
    // 機種関連パラメータ 商品カテゴリがiPhone、スマートフォン、Google Pixelの場合
    if (ITEM_TYPE_W2T.indexOf(arr.itemType) > -1) {
        var denwatenTargetFlg = 0;
        $.each(goodsStock, function (r, stockInfo) {
            var goodsConditionList = stockInfo.goodsCondition;
            if (!isEmpty(params.goodsCd)) {
                $.each(goodsConditionList, function (a, goodsCondition) {
                    if (params.goodsCd == goodsCondition.goodsCd && goodsCondition.receiptNewO2o
                        && goodsCondition.receiptNewO2o == SALES_RECEIPT.Y) {
                        denwatenTargetFlg++;
                        return false;
                    }
                });
            } else if (!isEmpty(params.modelId)) {
                if (params.modelId == stockInfo.modelId) {
                    $.each(goodsConditionList, function (a, goodsCondition) {
                        if (goodsCondition.receiptNewO2o &&
                            goodsCondition.receiptNewO2o == SALES_RECEIPT.Y) {
                            denwatenTargetFlg++;
                            return false;
                        }
                    });
                }
            } else if (!isEmpty(params.modelGrpCd)) {
                $.each(modelData.itemTypeList, function (i, itemType) {
                    $.each(itemType.modelGrpList, function (i, modelGrp) {
                        if (modelGrp.modelGrpCd == params.modelGrpCd) {
                            $.each(modelGrp.modelIdList, function (i, modelId) {
                                if (modelId.modelId == stockInfo.modelId) {
                                    $.each(goodsConditionList, function (a, goodsCondition) {
                                        if (goodsCondition.receiptNewO2o &&
                                            goodsCondition.receiptNewO2o == SALES_RECEIPT.Y) {
                                            denwatenTargetFlg++;
                                            return false;
                                        }
                                    });
                                }
                            });
                        }
                    });
                });
            } else if (!isEmpty(params.spGrpCd)) {
                $.each(g_spGrpData.modelGrpCdList, function (i, spModelGrpCd) {
                    $.each(modelData.itemTypeList, function (i, itemType) {
                        $.each(itemType.modelGrpList, function (i, modelGrp) {
                            if (modelGrp.modelGrpCd == spModelGrpCd) {
                                $.each(modelGrp.modelIdList, function (i, modelId) {
                                    if (modelId.modelId == stockInfo.modelId) {
                                        $.each(goodsConditionList, function (a, goodsCondition) {
                                            if (goodsCondition.receiptNewO2o &&
                                                goodsCondition.receiptNewO2o == SALES_RECEIPT.Y) {
                                                denwatenTargetFlg++;
                                                return false;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    });
                });
            } else if (!isEmpty(params.itemType)) {
                $.each(modelData.itemTypeList, function (i, itemType) {
                    if (params.itemType == itemType.itemTypeCd) {
                        $.each(itemType.modelGrpList, function (i, modelGrp) {
                            $.each(modelGrp.modelIdList, function (i, modelId) {
                                if (modelId.modelId == stockInfo.modelId) {
                                    $.each(goodsConditionList, function (a, goodsCondition) {
                                        if (goodsCondition.receiptNewO2o &&
                                            goodsCondition.receiptNewO2o == SALES_RECEIPT.Y) {
                                            denwatenTargetFlg++;
                                            return false;
                                        }
                                    });
                                }
                            });
                        });
                    }
                });
            }
        });
        // o2o対象が存在しない
        if (denwatenTargetFlg == 0) {
            location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_notapply", "errPage")));
            throw new error();
        }
    } else {
        location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_request", "errPage")));
        throw new error();
    }
}

/**
 * 機種関連外部パラメータで指定された機種が購入できない場合、ショップ検索画面にリダイレクトする
 * @param goodsCdArr
 * @param goodsStock
 * @param kubun 0：初期チェック/1：次へのチェック
 */
function goodsCdUseChk(goodsCdArr, goodsStock, kubun) {
    var returnVal = true;
    var goodsCdUseChkFlg = false;
    var flg = false;
    $.each(goodsCdArr, function (s, goodsCd) {
        $.each(goodsStock, function (r, stockInfo) {
            var goodsConditionList = stockInfo.goodsCondition;
            $.each(goodsConditionList, function (a, goodsCondition) {
                if (goodsCd == goodsCondition.goodsCd) {
                    // 機種関連外部パラメータを指定した受取方法対応フラグのチェック
                    if (getReceiptInfo(goodsCondition)) {
                        goodsCdUseChkFlg = true;
                        flg = true;
                        return false;
                    }
                }
            });
            if (flg) {
                return false;
            }
        });
        if (flg) {
            return false;
        }
    });

    // 受取方法対応フラグが非対応（N）になっている場合
    if (!goodsCdUseChkFlg) {
        if (kubun == 1) {
            alert(getMessage("message_alert_param"));
		} else {

            // ショップ検索画面へ遷移
            location.replace(SHOP_SEARCH_URL);
            throw new error();
        }
        returnVal = false;
    }
    return returnVal;
}

/**
 * 指定された機種関連パラメータで商品コードを取得
 * @param modelData
 * @param arr
 * @return goodsCdArr
*/
function getGoodsCdInfo(modelData, arr) {
    var goodsCd = "";
    var goodsCdArr = [];
    // 商品コード指定
    if (!isEmpty(params.goodsCd)) {

        goodsCd = arr.goodsCd;
        goodsCdArr.push(goodsCd);

    } else if (!isEmpty(params.modelId)) {
        // 機種コード指定
        var itemTypeList = sortArray(modelData.itemTypeList, "itemTypeSort");
        $.each(itemTypeList, function (c, itemTypeInfo) {
            var modelGrpList = sortArray(itemTypeInfo.modelGrpList, "modelGrpSort");
            $.each(modelGrpList, function (g, modelGrpInfo) {
                var modelIdList = sortArray(modelGrpInfo.modelIdList, "modelIdSort");
                $.each(modelIdList, function (m, modelInfo) {
                    if (modelInfo.modelId == params.modelId) {
                        var goodsCdList = sortArray(modelInfo.goodsCdList, "goodsCdSort");
                        $.each(goodsCdList, function (n, goodsInfo) {
                            goodsCd = goodsInfo.goodsCd;
                            goodsCdArr.push(goodsCd);
                        });
                    }
                });
            });
        });
    } else if (!isEmpty(params.modelGrpCd)) {
        // 機種グループコード指定
        var itemTypeList = sortArray(modelData.itemTypeList, "itemTypeSort");
        $.each(itemTypeList, function (c, itemTypeInfo) {
            var modelGrpList = sortArray(itemTypeInfo.modelGrpList, "modelGrpSort");
            $.each(modelGrpList, function (g, modelGrpInfo) {
                if (modelGrpInfo.modelGrpCd == params.modelGrpCd) {
                    var modelIdList = sortArray(modelGrpInfo.modelIdList, "modelIdSort");
                    $.each(modelIdList, function (m, modelInfo) {
                        var goodsCdList = sortArray(modelInfo.goodsCdList, "goodsCdSort");
                        $.each(goodsCdList, function (n, goodsInfo) {
                            goodsCd = goodsInfo.goodsCd;
                            goodsCdArr.push(goodsCd);
                        });
                    });
                }
            });
        });
    } else if (!isEmpty(params.spGrpCd)) {
        // 特定グループコード指定
        $.each(g_spGrpData.modelGrpCdList, function (g, spModelGrpCd) {
            var itemTypeList = sortArray(modelData.itemTypeList, "itemTypeSort");
            $.each(itemTypeList, function (m, itemTypeInfo) {
                var modelGrpList = sortArray(itemTypeInfo.modelGrpList, "modelGrpSort");
                $.each(modelGrpList, function (n, modelGrpInfo) {
                    if (modelGrpInfo.modelGrpCd == spModelGrpCd) {
                        var modelIdList = sortArray(modelGrpInfo.modelIdList, "modelIdSort");
                        $.each(modelIdList, function (i, modelInfo) {
                            var goodsCdList = sortArray(modelInfo.goodsCdList, "goodsCdSort");
                            $.each(goodsCdList, function (j, goodsInfo) {
                                goodsCd = goodsInfo.goodsCd;
                                goodsCdArr.push(goodsCd);
                            });
                        });
                    }
                });
            });
        });
    } else if (!isEmpty(params.itemType)) {
        // 商品カテゴリ指定
        var itemTypeList = sortArray(modelData.itemTypeList, "itemTypeSort");
        $.each(itemTypeList, function (c, itemTypeInfo) {
            if (itemTypeInfo.itemTypeCd == params.itemType) {
                var modelGrpList = sortArray(itemTypeInfo.modelGrpList, "modelGrpSort");
                $.each(modelGrpList, function (g, modelGrpInfo) {
                    var modelIdList = sortArray(modelGrpInfo.modelIdList, "modelIdSort");
                    $.each(modelIdList, function (m, modelInfo) {
                        var goodsCdList = sortArray(modelInfo.goodsCdList, "goodsCdSort");
                        $.each(goodsCdList, function (n, goodsInfo) {
                            goodsCd = goodsInfo.goodsCd;
                            goodsCdArr.push(goodsCd);
                        });
                    });
                });
            }
        });
    }
    return goodsCdArr;
}

/**
 * 受取方法対応フラグのチェック
 * @param goodsCondition
 */
function getReceiptInfo(goodsCondition) {
    var receiptFlg = false;
    var receiptVal = isEmpty($("[name='receiptChgCtrl']:checked").val()) ? params.receiptStyleCtrl : $("[name='receiptChgCtrl']:checked").val();
    // 受取方法が外部パラメータ（2,3以外）で変更可の場合
    if (receiptVal != RECEIPT_STYLE_CTRL.HOME && receiptVal != RECEIPT_STYLE_CTRL.SHOP) {
        if (goodsCondition.receiptDirect != SALES_RECEIPT.NG || goodsCondition.receiptNewO2o != SALES_RECEIPT.NG) {
            receiptFlg = true;
        }
        // 受取方法が外部パラメータ（2,3）で変更不可の場合
    } else {
        //W2T予約申込の場合
        if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID) {
            if (goodsCondition.receiptNewO2o != SALES_RECEIPT.NG) {
                receiptFlg = true;
            }
        //受取方法：直送固定
        } else if (receiptVal == RECEIPT_STYLE_CTRL.HOME) {
            if (goodsCondition.receiptDirect != SALES_RECEIPT.NG) {
                receiptFlg = true;
            }

            // 受取方法：o2o固定
        } else if (receiptVal == RECEIPT_STYLE_CTRL.SHOP) {
            if (goodsCondition.receiptNewO2o != SALES_RECEIPT.NG) {
                receiptFlg = true;
            }
        }
    }
    return receiptFlg;
}

// 受付業務o2o/W2T判定
function isO2OorW2T() {
	if (params.agncyId == SOFTBANK_DENWATEN_AGENCY_ID || $("input[name=receiptChgCtrl]:checked").val() == RECEIPT_STYLE_CTRL_SHOP) {
		return true;
	} else {
		return false;
	}
}